import _construct from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import _get from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _slicedToArray from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/*! (c) 2019-2021 pixiv Inc. - https://github.com/pixiv/three-vrm/blob/release/LICENSE */
import * as e from "three";
import { BufferAttribute as t } from "three";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function n(e, t, n, i) {
  return new (n || (n = Promise))(function (r, o) {
    function s(e) {
      try {
        l(i.next(e));
      } catch (e) {
        o(e);
      }
    }

    function a(e) {
      try {
        l(i.throw(e));
      } catch (e) {
        o(e);
      }
    }

    function l(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(s, a);
    }

    l((i = i.apply(e, t || [])).next());
  });
}

function i(e) {
  Object.keys(e).forEach(function (t) {
    var n = e[t];

    if (null == n ? void 0 : n.isTexture) {
      n.dispose();
    }
  }), e.dispose();
}

function r(e) {
  var t = e.geometry;
  t && t.dispose();
  var n = e.material;
  n && (Array.isArray(n) ? n.forEach(function (e) {
    return i(e);
  }) : n && i(n));
}

var o;
!function (e) {
  e[e.NUMBER = 0] = "NUMBER", e[e.VECTOR2 = 1] = "VECTOR2", e[e.VECTOR3 = 2] = "VECTOR3", e[e.VECTOR4 = 3] = "VECTOR4", e[e.COLOR = 4] = "COLOR";
}(o || (o = {}));
var s = new e.Vector2(),
    a = new e.Vector3(),
    l = new e.Vector4(),
    d = new e.Color();

var h = /*#__PURE__*/function (_e$Object3D) {
  _inherits(h, _e$Object3D);

  function h(e) {
    var _this;

    _classCallCheck(this, h);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this)), _this.weight = 0, _this.isBinary = !1, _this._binds = [], _this._materialValues = [], _this.name = "BlendShapeController_".concat(e), _this.type = "BlendShapeController", _this.visible = !1;
    return _this;
  }

  _createClass(h, [{
    key: "addBind",
    value: function addBind(e) {
      var t = e.weight / 100;

      this._binds.push({
        meshes: e.meshes,
        morphTargetIndex: e.morphTargetIndex,
        weight: t
      });
    }
  }, {
    key: "addMaterialValue",
    value: function addMaterialValue(t) {
      var n = t.material,
          i = t.propertyName;
      var r,
          s,
          a,
          l,
          d = n[i];
      d && (d = t.defaultValue || d, d.isVector2 ? (r = o.VECTOR2, s = d.clone(), a = new e.Vector2().fromArray(t.targetValue), l = a.clone().sub(s)) : d.isVector3 ? (r = o.VECTOR3, s = d.clone(), a = new e.Vector3().fromArray(t.targetValue), l = a.clone().sub(s)) : d.isVector4 ? (r = o.VECTOR4, s = d.clone(), a = new e.Vector4().fromArray([t.targetValue[2], t.targetValue[3], t.targetValue[0], t.targetValue[1]]), l = a.clone().sub(s)) : d.isColor ? (r = o.COLOR, s = d.clone(), a = new e.Color().fromArray(t.targetValue), l = a.clone().sub(s)) : (r = o.NUMBER, s = d, a = t.targetValue[0], l = a - s), this._materialValues.push({
        material: n,
        propertyName: i,
        defaultValue: s,
        targetValue: a,
        deltaValue: l,
        type: r
      }));
    }
  }, {
    key: "applyWeight",
    value: function applyWeight() {
      var e = this.isBinary ? this.weight < .5 ? 0 : 1 : this.weight;
      this._binds.forEach(function (t) {
        t.meshes.forEach(function (n) {
          n.morphTargetInfluences && (n.morphTargetInfluences[t.morphTargetIndex] += e * t.weight);
        });
      }), this._materialValues.forEach(function (t) {
        if (void 0 !== t.material[t.propertyName]) {
          if (t.type === o.NUMBER) {
            var _n = t.deltaValue;
            t.material[t.propertyName] += _n * e;
          } else if (t.type === o.VECTOR2) {
            var _n2 = t.deltaValue;
            t.material[t.propertyName].add(s.copy(_n2).multiplyScalar(e));
          } else if (t.type === o.VECTOR3) {
            var _n3 = t.deltaValue;
            t.material[t.propertyName].add(a.copy(_n3).multiplyScalar(e));
          } else if (t.type === o.VECTOR4) {
            var _n4 = t.deltaValue;
            t.material[t.propertyName].add(l.copy(_n4).multiplyScalar(e));
          } else if (t.type === o.COLOR) {
            var _n5 = t.deltaValue;
            t.material[t.propertyName].add(d.copy(_n5).multiplyScalar(e));
          }

          "boolean" == typeof t.material.shouldApplyUniforms && (t.material.shouldApplyUniforms = !0);
        }
      });
    }
  }, {
    key: "clearAppliedWeight",
    value: function clearAppliedWeight() {
      this._binds.forEach(function (e) {
        e.meshes.forEach(function (t) {
          t.morphTargetInfluences && (t.morphTargetInfluences[e.morphTargetIndex] = 0);
        });
      }), this._materialValues.forEach(function (e) {
        if (void 0 !== e.material[e.propertyName]) {
          if (e.type === o.NUMBER) {
            var _t = e.defaultValue;
            e.material[e.propertyName] = _t;
          } else if (e.type === o.VECTOR2) {
            var _t2 = e.defaultValue;
            e.material[e.propertyName].copy(_t2);
          } else if (e.type === o.VECTOR3) {
            var _t3 = e.defaultValue;
            e.material[e.propertyName].copy(_t3);
          } else if (e.type === o.VECTOR4) {
            var _t4 = e.defaultValue;
            e.material[e.propertyName].copy(_t4);
          } else if (e.type === o.COLOR) {
            var _t5 = e.defaultValue;
            e.material[e.propertyName].copy(_t5);
          }

          "boolean" == typeof e.material.shouldApplyUniforms && (e.material.shouldApplyUniforms = !0);
        }
      });
    }
  }]);

  return h;
}(e.Object3D);

var u;

function c(e, t, n) {
  var i = e.parser.json.nodes[t].mesh;
  if (null == i) return null;
  var r = e.parser.json.meshes[i].primitives.length,
      o = [];
  return n.traverse(function (e) {
    o.length < r && e.isMesh && o.push(e);
  }), o;
}

function p(e) {
  return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var t, n;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return e.parser.getDependencies("node");

          case 2:
            t = _context.sent;
            n = new Map();
            return _context.abrupt("return", (t.forEach(function (t, i) {
              var r = c(e, i, t);
              null != r && n.set(i, r);
            }), n));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function m(e) {
  return "_" !== e[0] ? (console.warn("renameMaterialProperty: Given property name \"".concat(e, "\" might be invalid")), e) : (e = e.substring(1), /[A-Z]/.test(e[0]) ? e[0].toLowerCase() + e.substring(1) : (console.warn("renameMaterialProperty: Given property name \"".concat(e, "\" might be invalid")), e));
}

!function (e) {
  var t, n, i, r, o, s;
  (t = e.BlendShapePresetName || (e.BlendShapePresetName = {})).A = "a", t.Angry = "angry", t.Blink = "blink", t.BlinkL = "blink_l", t.BlinkR = "blink_r", t.E = "e", t.Fun = "fun", t.I = "i", t.Joy = "joy", t.Lookdown = "lookdown", t.Lookleft = "lookleft", t.Lookright = "lookright", t.Lookup = "lookup", t.Neutral = "neutral", t.O = "o", t.Sorrow = "sorrow", t.U = "u", t.Unknown = "unknown", (n = e.FirstPersonLookAtTypeName || (e.FirstPersonLookAtTypeName = {})).BlendShape = "BlendShape", n.Bone = "Bone", (i = e.HumanoidBoneName || (e.HumanoidBoneName = {})).Chest = "chest", i.Head = "head", i.Hips = "hips", i.Jaw = "jaw", i.LeftEye = "leftEye", i.LeftFoot = "leftFoot", i.LeftHand = "leftHand", i.LeftIndexDistal = "leftIndexDistal", i.LeftIndexIntermediate = "leftIndexIntermediate", i.LeftIndexProximal = "leftIndexProximal", i.LeftLittleDistal = "leftLittleDistal", i.LeftLittleIntermediate = "leftLittleIntermediate", i.LeftLittleProximal = "leftLittleProximal", i.LeftLowerArm = "leftLowerArm", i.LeftLowerLeg = "leftLowerLeg", i.LeftMiddleDistal = "leftMiddleDistal", i.LeftMiddleIntermediate = "leftMiddleIntermediate", i.LeftMiddleProximal = "leftMiddleProximal", i.LeftRingDistal = "leftRingDistal", i.LeftRingIntermediate = "leftRingIntermediate", i.LeftRingProximal = "leftRingProximal", i.LeftShoulder = "leftShoulder", i.LeftThumbDistal = "leftThumbDistal", i.LeftThumbIntermediate = "leftThumbIntermediate", i.LeftThumbProximal = "leftThumbProximal", i.LeftToes = "leftToes", i.LeftUpperArm = "leftUpperArm", i.LeftUpperLeg = "leftUpperLeg", i.Neck = "neck", i.RightEye = "rightEye", i.RightFoot = "rightFoot", i.RightHand = "rightHand", i.RightIndexDistal = "rightIndexDistal", i.RightIndexIntermediate = "rightIndexIntermediate", i.RightIndexProximal = "rightIndexProximal", i.RightLittleDistal = "rightLittleDistal", i.RightLittleIntermediate = "rightLittleIntermediate", i.RightLittleProximal = "rightLittleProximal", i.RightLowerArm = "rightLowerArm", i.RightLowerLeg = "rightLowerLeg", i.RightMiddleDistal = "rightMiddleDistal", i.RightMiddleIntermediate = "rightMiddleIntermediate", i.RightMiddleProximal = "rightMiddleProximal", i.RightRingDistal = "rightRingDistal", i.RightRingIntermediate = "rightRingIntermediate", i.RightRingProximal = "rightRingProximal", i.RightShoulder = "rightShoulder", i.RightThumbDistal = "rightThumbDistal", i.RightThumbIntermediate = "rightThumbIntermediate", i.RightThumbProximal = "rightThumbProximal", i.RightToes = "rightToes", i.RightUpperArm = "rightUpperArm", i.RightUpperLeg = "rightUpperLeg", i.Spine = "spine", i.UpperChest = "upperChest", (r = e.MetaAllowedUserName || (e.MetaAllowedUserName = {})).Everyone = "Everyone", r.ExplicitlyLicensedPerson = "ExplicitlyLicensedPerson", r.OnlyAuthor = "OnlyAuthor", (o = e.MetaUssageName || (e.MetaUssageName = {})).Allow = "Allow", o.Disallow = "Disallow", (s = e.MetaLicenseName || (e.MetaLicenseName = {})).Cc0 = "CC0", s.CcBy = "CC_BY", s.CcByNc = "CC_BY_NC", s.CcByNcNd = "CC_BY_NC_ND", s.CcByNcSa = "CC_BY_NC_SA", s.CcByNd = "CC_BY_ND", s.CcBySa = "CC_BY_SA", s.Other = "Other", s.RedistributionProhibited = "Redistribution_Prohibited";
}(u || (u = {}));
var f = new e.Vector3(),
    g = new e.Vector3();

function _(e, t) {
  return e.matrixWorld.decompose(f, t, g), t;
}

new e.Quaternion();

var v = /*#__PURE__*/function () {
  function v() {
    _classCallCheck(this, v);

    this._blendShapeGroups = {}, this._blendShapePresetMap = {}, this._unknownGroupNames = [];
  }

  _createClass(v, [{
    key: "getBlendShapeGroup",
    value: function getBlendShapeGroup(e) {
      var t = this._blendShapePresetMap[e],
          n = t ? this._blendShapeGroups[t] : this._blendShapeGroups[e];
      if (n) return n;
      console.warn("no blend shape found by ".concat(e));
    }
  }, {
    key: "registerBlendShapeGroup",
    value: function registerBlendShapeGroup(e, t, n) {
      this._blendShapeGroups[e] = n, t ? this._blendShapePresetMap[t] = e : this._unknownGroupNames.push(e);
    }
  }, {
    key: "getValue",
    value: function getValue(e) {
      var t;
      var n = this.getBlendShapeGroup(e);
      return null !== (t = null == n ? void 0 : n.weight) && void 0 !== t ? t : null;
    }
  }, {
    key: "setValue",
    value: function setValue(e, t) {
      var n = this.getBlendShapeGroup(e);
      var i;
      n && (n.weight = (i = t, Math.max(Math.min(i, 1), 0)));
    }
  }, {
    key: "getBlendShapeTrackName",
    value: function getBlendShapeTrackName(e) {
      var t = this.getBlendShapeGroup(e);
      return t ? "".concat(t.name, ".weight") : null;
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;

      Object.keys(this._blendShapeGroups).forEach(function (e) {
        _this2._blendShapeGroups[e].clearAppliedWeight();
      }), Object.keys(this._blendShapeGroups).forEach(function (e) {
        _this2._blendShapeGroups[e].applyWeight();
      });
    }
  }, {
    key: "expressions",
    get: function get() {
      return Object.keys(this._blendShapeGroups);
    }
  }, {
    key: "blendShapePresetMap",
    get: function get() {
      return this._blendShapePresetMap;
    }
  }, {
    key: "unknownGroupNames",
    get: function get() {
      return this._unknownGroupNames;
    }
  }]);

  return v;
}();

var T = /*#__PURE__*/function () {
  function T() {
    _classCallCheck(this, T);
  }

  _createClass(T, [{
    key: "import",
    value: function _import(e) {
      var t;
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;

        var i, r, o, s, a;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                i = null === (t = e.parser.json.extensions) || void 0 === t ? void 0 : t.VRM;

                if (i) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", null);

              case 3:
                r = i.blendShapeMaster;

                if (r) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return", null);

              case 6:
                o = new v(), s = r.blendShapeGroups;

                if (s) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return", o);

              case 9:
                a = {};
                _context6.next = 12;
                return Promise.all(s.map(function (t) {
                  return n(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                    var _this4 = this;

                    var i, r, s, l;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            i = t.name;

                            if (!(void 0 === i)) {
                              _context5.next = 3;
                              break;
                            }

                            return _context5.abrupt("return", void console.warn("VRMBlendShapeImporter: One of blendShapeGroups has no name"));

                          case 3:
                            t.presetName && t.presetName !== u.BlendShapePresetName.Unknown && !a[t.presetName] && (r = t.presetName, a[t.presetName] = i);
                            s = new h(i);
                            e.scene.add(s), s.isBinary = t.isBinary || !1, t.binds && t.binds.forEach(function (i) {
                              return n(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                                var _this5 = this;

                                var r, o;
                                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                                  while (1) {
                                    switch (_context4.prev = _context4.next) {
                                      case 0:
                                        if (!(void 0 === i.mesh || void 0 === i.index)) {
                                          _context4.next = 2;
                                          break;
                                        }

                                        return _context4.abrupt("return");

                                      case 2:
                                        r = [];
                                        e.parser.json.nodes.forEach(function (e, t) {
                                          e.mesh === i.mesh && r.push(t);
                                        });
                                        o = i.index;
                                        _context4.next = 7;
                                        return Promise.all(r.map(function (r) {
                                          return n(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                                            var a, l;
                                            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                                              while (1) {
                                                switch (_context3.prev = _context3.next) {
                                                  case 0:
                                                    _context3.next = 2;
                                                    return function (e, t) {
                                                      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                                                        var n;
                                                        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                                          while (1) {
                                                            switch (_context2.prev = _context2.next) {
                                                              case 0:
                                                                _context2.next = 2;
                                                                return e.parser.getDependency("node", t);

                                                              case 2:
                                                                n = _context2.sent;
                                                                return _context2.abrupt("return", c(e, t, n));

                                                              case 4:
                                                              case "end":
                                                                return _context2.stop();
                                                            }
                                                          }
                                                        }, _callee2);
                                                      }));
                                                    }(e, r);

                                                  case 2:
                                                    l = _context3.sent;
                                                    l.every(function (e) {
                                                      return Array.isArray(e.morphTargetInfluences) && o < e.morphTargetInfluences.length;
                                                    }) ? s.addBind({
                                                      meshes: l,
                                                      morphTargetIndex: o,
                                                      weight: null !== (a = i.weight) && void 0 !== a ? a : 100
                                                    }) : console.warn("VRMBlendShapeImporter: ".concat(t.name, " attempts to index ").concat(o, "th morph but not found."));

                                                  case 4:
                                                  case "end":
                                                    return _context3.stop();
                                                }
                                              }
                                            }, _callee3);
                                          }));
                                        }));

                                      case 7:
                                      case "end":
                                        return _context4.stop();
                                    }
                                  }
                                }, _callee4);
                              }));
                            });
                            l = t.materialValues;
                            l && l.forEach(function (t) {
                              if (void 0 === t.materialName || void 0 === t.propertyName || void 0 === t.targetValue) return;
                              var n = [];
                              e.scene.traverse(function (e) {
                                if (e.material) {
                                  var _i = e.material;
                                  Array.isArray(_i) ? n.push.apply(n, _toConsumableArray(_i.filter(function (e) {
                                    return e.name === t.materialName && -1 === n.indexOf(e);
                                  }))) : _i.name === t.materialName && -1 === n.indexOf(_i) && n.push(_i);
                                }
                              }), n.forEach(function (e) {
                                s.addMaterialValue({
                                  material: e,
                                  propertyName: m(t.propertyName),
                                  targetValue: t.targetValue
                                });
                              });
                            }), o.registerBlendShapeGroup(i, r, s);

                          case 8:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));
                }));

              case 12:
                return _context6.abrupt("return", o);

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }]);

  return T;
}();

var y = Object.freeze(new e.Vector3(0, 0, -1)),
    x = new e.Quaternion();
var S;
!function (e) {
  e[e.Auto = 0] = "Auto", e[e.Both = 1] = "Both", e[e.ThirdPersonOnly = 2] = "ThirdPersonOnly", e[e.FirstPersonOnly = 3] = "FirstPersonOnly";
}(S || (S = {}));

var M = /*#__PURE__*/function () {
  function M(e, t) {
    _classCallCheck(this, M);

    this.firstPersonFlag = M._parseFirstPersonFlag(e), this.primitives = t;
  }

  _createClass(M, null, [{
    key: "_parseFirstPersonFlag",
    value: function _parseFirstPersonFlag(e) {
      switch (e) {
        case "Both":
          return S.Both;

        case "ThirdPersonOnly":
          return S.ThirdPersonOnly;

        case "FirstPersonOnly":
          return S.FirstPersonOnly;

        default:
          return S.Auto;
      }
    }
  }]);

  return M;
}();

var E = /*#__PURE__*/function () {
  function E(e, t, n) {
    _classCallCheck(this, E);

    this._meshAnnotations = [], this._firstPersonOnlyLayer = E._DEFAULT_FIRSTPERSON_ONLY_LAYER, this._thirdPersonOnlyLayer = E._DEFAULT_THIRDPERSON_ONLY_LAYER, this._initialized = !1, this._firstPersonBone = e, this._firstPersonBoneOffset = t, this._meshAnnotations = n;
  }

  _createClass(E, [{
    key: "getFirstPersonWorldDirection",
    value: function getFirstPersonWorldDirection(e) {
      return e.copy(y).applyQuaternion(_(this._firstPersonBone, x));
    }
  }, {
    key: "getFirstPersonBoneOffset",
    value: function getFirstPersonBoneOffset(e) {
      return e.copy(this._firstPersonBoneOffset);
    }
  }, {
    key: "getFirstPersonWorldPosition",
    value: function getFirstPersonWorldPosition(t) {
      var n = this._firstPersonBoneOffset,
          i = new e.Vector4(n.x, n.y, n.z, 1);
      return i.applyMatrix4(this._firstPersonBone.matrixWorld), t.set(i.x, i.y, i.z);
    }
  }, {
    key: "setup",
    value: function setup() {
      var _this6 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$firstPersonOnlyL = _ref.firstPersonOnlyLayer,
          e = _ref$firstPersonOnlyL === void 0 ? E._DEFAULT_FIRSTPERSON_ONLY_LAYER : _ref$firstPersonOnlyL,
          _ref$thirdPersonOnlyL = _ref.thirdPersonOnlyLayer,
          t = _ref$thirdPersonOnlyL === void 0 ? E._DEFAULT_THIRDPERSON_ONLY_LAYER : _ref$thirdPersonOnlyL;

      this._initialized || (this._initialized = !0, this._firstPersonOnlyLayer = e, this._thirdPersonOnlyLayer = t, this._meshAnnotations.forEach(function (e) {
        e.firstPersonFlag === S.FirstPersonOnly ? e.primitives.forEach(function (e) {
          e.layers.set(_this6._firstPersonOnlyLayer);
        }) : e.firstPersonFlag === S.ThirdPersonOnly ? e.primitives.forEach(function (e) {
          e.layers.set(_this6._thirdPersonOnlyLayer);
        }) : e.firstPersonFlag === S.Auto && _this6._createHeadlessModel(e.primitives);
      }));
    }
  }, {
    key: "_excludeTriangles",
    value: function _excludeTriangles(e, t, n, i) {
      var r = 0;
      if (null != t && t.length > 0) for (var _o = 0; _o < e.length; _o += 3) {
        var _s = e[_o],
            a = e[_o + 1],
            _l = e[_o + 2],
            _d = t[_s],
            _h = n[_s];
        if (_d[0] > 0 && i.includes(_h[0])) continue;
        if (_d[1] > 0 && i.includes(_h[1])) continue;
        if (_d[2] > 0 && i.includes(_h[2])) continue;
        if (_d[3] > 0 && i.includes(_h[3])) continue;
        var _u = t[a],
            _c = n[a];
        if (_u[0] > 0 && i.includes(_c[0])) continue;
        if (_u[1] > 0 && i.includes(_c[1])) continue;
        if (_u[2] > 0 && i.includes(_c[2])) continue;
        if (_u[3] > 0 && i.includes(_c[3])) continue;
        var _p = t[_l],
            _m = n[_l];
        _p[0] > 0 && i.includes(_m[0]) || _p[1] > 0 && i.includes(_m[1]) || _p[2] > 0 && i.includes(_m[2]) || _p[3] > 0 && i.includes(_m[3]) || (e[r++] = _s, e[r++] = a, e[r++] = _l);
      }
      return r;
    }
  }, {
    key: "_createErasedMesh",
    value: function _createErasedMesh(t, n) {
      var i = new e.SkinnedMesh(t.geometry.clone(), t.material);
      i.name = "".concat(t.name, "(erase)"), i.frustumCulled = t.frustumCulled, i.layers.set(this._firstPersonOnlyLayer);
      var r = i.geometry,
          o = r.getAttribute("skinIndex").array,
          s = [];

      for (var _e2 = 0; _e2 < o.length; _e2 += 4) {
        s.push([o[_e2], o[_e2 + 1], o[_e2 + 2], o[_e2 + 3]]);
      }

      var a = r.getAttribute("skinWeight").array,
          l = [];

      for (var _e3 = 0; _e3 < a.length; _e3 += 4) {
        l.push([a[_e3], a[_e3 + 1], a[_e3 + 2], a[_e3 + 3]]);
      }

      var d = r.getIndex();
      if (!d) throw new Error("The geometry doesn't have an index buffer");

      var h = Array.from(d.array),
          u = this._excludeTriangles(h, l, s, n),
          c = [];

      for (var _e4 = 0; _e4 < u; _e4++) {
        c[_e4] = h[_e4];
      }

      return r.setIndex(c), t.onBeforeRender && (i.onBeforeRender = t.onBeforeRender), i.bind(new e.Skeleton(t.skeleton.bones, t.skeleton.boneInverses), new e.Matrix4()), i;
    }
  }, {
    key: "_createHeadlessModelForSkinnedMesh",
    value: function _createHeadlessModelForSkinnedMesh(e, t) {
      var _this7 = this;

      var n = [];
      if (t.skeleton.bones.forEach(function (e, t) {
        _this7._isEraseTarget(e) && n.push(t);
      }), !n.length) return t.layers.enable(this._thirdPersonOnlyLayer), void t.layers.enable(this._firstPersonOnlyLayer);
      t.layers.set(this._thirdPersonOnlyLayer);

      var i = this._createErasedMesh(t, n);

      e.add(i);
    }
  }, {
    key: "_createHeadlessModel",
    value: function _createHeadlessModel(e) {
      var _this8 = this;

      e.forEach(function (e) {
        if ("SkinnedMesh" === e.type) {
          var _t6 = e;

          _this8._createHeadlessModelForSkinnedMesh(_t6.parent, _t6);
        } else _this8._isEraseTarget(e) && e.layers.set(_this8._thirdPersonOnlyLayer);
      });
    }
  }, {
    key: "_isEraseTarget",
    value: function _isEraseTarget(e) {
      return e === this._firstPersonBone || !!e.parent && this._isEraseTarget(e.parent);
    }
  }, {
    key: "firstPersonBone",
    get: function get() {
      return this._firstPersonBone;
    }
  }, {
    key: "meshAnnotations",
    get: function get() {
      return this._meshAnnotations;
    }
  }, {
    key: "firstPersonOnlyLayer",
    get: function get() {
      return this._firstPersonOnlyLayer;
    }
  }, {
    key: "thirdPersonOnlyLayer",
    get: function get() {
      return this._thirdPersonOnlyLayer;
    }
  }]);

  return E;
}();

E._DEFAULT_FIRSTPERSON_ONLY_LAYER = 9, E._DEFAULT_THIRDPERSON_ONLY_LAYER = 10;

var L = /*#__PURE__*/function () {
  function L() {
    _classCallCheck(this, L);
  }

  _createClass(L, [{
    key: "import",
    value: function _import(t, i) {
      var r;
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var n, o, s, a, l, d, h;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                n = null === (r = t.parser.json.extensions) || void 0 === r ? void 0 : r.VRM;

                if (n) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return", null);

              case 3:
                o = n.firstPerson;

                if (o) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt("return", null);

              case 6:
                s = o.firstPersonBone;

                if (!(void 0 === s || -1 === s)) {
                  _context7.next = 11;
                  break;
                }

                _context7.t0 = i.getBoneNode(u.HumanoidBoneName.Head);
                _context7.next = 14;
                break;

              case 11:
                _context7.next = 13;
                return t.parser.getDependency("node", s);

              case 13:
                _context7.t0 = _context7.sent;

              case 14:
                a = _context7.t0;

                if (a) {
                  _context7.next = 17;
                  break;
                }

                return _context7.abrupt("return", (console.warn("VRMFirstPersonImporter: Could not find firstPersonBone of the VRM"), null));

              case 17:
                l = o.firstPersonBoneOffset ? new e.Vector3(o.firstPersonBoneOffset.x, o.firstPersonBoneOffset.y, -o.firstPersonBoneOffset.z) : new e.Vector3(0, .06, 0);
                d = [];
                _context7.next = 21;
                return p(t);

              case 21:
                h = _context7.sent;
                return _context7.abrupt("return", (Array.from(h.entries()).forEach(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                      e = _ref3[0],
                      n = _ref3[1];

                  var i = t.parser.json.nodes[e],
                      r = o.meshAnnotations ? o.meshAnnotations.find(function (e) {
                    return e.mesh === i.mesh;
                  }) : void 0;
                  d.push(new M(null == r ? void 0 : r.firstPersonFlag, n));
                }), new E(a, l, d)));

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
  }]);

  return L;
}();

var R = function R(e, t) {
  _classCallCheck(this, R);

  this.node = e, this.humanLimit = t;
};

function w(e) {
  return e.invert ? e.invert() : e.inverse(), e;
}

var P = new e.Vector3(),
    A = new e.Quaternion();

var I = /*#__PURE__*/function () {
  function I(e, t) {
    _classCallCheck(this, I);

    this.restPose = {}, this.humanBones = this._createHumanBones(e), this.humanDescription = t, this.restPose = this.getPose();
  }

  _createClass(I, [{
    key: "getPose",
    value: function getPose() {
      var _this9 = this;

      var e = {};
      return Object.keys(this.humanBones).forEach(function (t) {
        var n = _this9.getBoneNode(t);

        if (!n) return;
        if (e[t]) return;
        P.set(0, 0, 0), A.identity();
        var i = _this9.restPose[t];
        (null == i ? void 0 : i.position) && P.fromArray(i.position).negate(), (null == i ? void 0 : i.rotation) && w(A.fromArray(i.rotation)), P.add(n.position), A.premultiply(n.quaternion), e[t] = {
          position: P.toArray(),
          rotation: A.toArray()
        };
      }, {}), e;
    }
  }, {
    key: "setPose",
    value: function setPose(e) {
      var _this10 = this;

      Object.keys(e).forEach(function (t) {
        var n = e[t],
            i = _this10.getBoneNode(t);

        if (!i) return;
        var r = _this10.restPose[t];
        r && (n.position && (i.position.fromArray(n.position), r.position && i.position.add(P.fromArray(r.position))), n.rotation && (i.quaternion.fromArray(n.rotation), r.rotation && i.quaternion.multiply(A.fromArray(r.rotation))));
      });
    }
  }, {
    key: "resetPose",
    value: function resetPose() {
      var _this11 = this;

      Object.entries(this.restPose).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            e = _ref5[0],
            t = _ref5[1];

        var n = _this11.getBoneNode(e);

        n && ((null == t ? void 0 : t.position) && n.position.fromArray(t.position), (null == t ? void 0 : t.rotation) && n.quaternion.fromArray(t.rotation));
      });
    }
  }, {
    key: "getBone",
    value: function getBone(e) {
      var t;
      return null !== (t = this.humanBones[e][0]) && void 0 !== t ? t : void 0;
    }
  }, {
    key: "getBones",
    value: function getBones(e) {
      var t;
      return null !== (t = this.humanBones[e]) && void 0 !== t ? t : [];
    }
  }, {
    key: "getBoneNode",
    value: function getBoneNode(e) {
      var t, n;
      return null !== (n = null === (t = this.humanBones[e][0]) || void 0 === t ? void 0 : t.node) && void 0 !== n ? n : null;
    }
  }, {
    key: "getBoneNodes",
    value: function getBoneNodes(e) {
      var t, n;
      return null !== (n = null === (t = this.humanBones[e]) || void 0 === t ? void 0 : t.map(function (e) {
        return e.node;
      })) && void 0 !== n ? n : [];
    }
  }, {
    key: "_createHumanBones",
    value: function _createHumanBones(e) {
      var t = Object.values(u.HumanoidBoneName).reduce(function (e, t) {
        return e[t] = [], e;
      }, {});
      return e.forEach(function (e) {
        t[e.name].push(e.bone);
      }), t;
    }
  }]);

  return I;
}();

var b = /*#__PURE__*/function () {
  function b() {
    _classCallCheck(this, b);
  }

  _createClass(b, [{
    key: "import",
    value: function _import(t) {
      var i;
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this12 = this;

        var r, o, s, a;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                r = null === (i = t.parser.json.extensions) || void 0 === i ? void 0 : i.VRM;

                if (r) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return", null);

              case 3:
                o = r.humanoid;

                if (o) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt("return", null);

              case 6:
                s = [];
                _context9.t0 = o.humanBones;

                if (!_context9.t0) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 11;
                return Promise.all(o.humanBones.map(function (i) {
                  return n(_this12, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                    var n;
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!(!i.bone || null == i.node)) {
                              _context8.next = 2;
                              break;
                            }

                            return _context8.abrupt("return");

                          case 2:
                            _context8.next = 4;
                            return t.parser.getDependency("node", i.node);

                          case 4:
                            n = _context8.sent;
                            s.push({
                              name: i.bone,
                              bone: new R(n, {
                                axisLength: i.axisLength,
                                center: i.center && new e.Vector3(i.center.x, i.center.y, i.center.z),
                                max: i.max && new e.Vector3(i.max.x, i.max.y, i.max.z),
                                min: i.min && new e.Vector3(i.min.x, i.min.y, i.min.z),
                                useDefaultValues: i.useDefaultValues
                              })
                            });

                          case 6:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));
                }));

              case 11:
                a = {
                  armStretch: o.armStretch,
                  legStretch: o.legStretch,
                  upperArmTwist: o.upperArmTwist,
                  lowerArmTwist: o.lowerArmTwist,
                  upperLegTwist: o.upperLegTwist,
                  lowerLegTwist: o.lowerLegTwist,
                  feetSpacing: o.feetSpacing,
                  hasTranslationDoF: o.hasTranslationDoF
                };
                return _context9.abrupt("return", new I(s, a));

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    }
  }]);

  return b;
}();

var O = /*#__PURE__*/function () {
  function O(e, t, n) {
    _classCallCheck(this, O);

    this.curve = [0, 0, 0, 1, 1, 1, 1, 0], this.curveXRangeDegree = 90, this.curveYRangeDegree = 10, void 0 !== e && (this.curveXRangeDegree = e), void 0 !== t && (this.curveYRangeDegree = t), void 0 !== n && (this.curve = n);
  }

  _createClass(O, [{
    key: "map",
    value: function map(e) {
      var t = Math.min(Math.max(e, 0), this.curveXRangeDegree) / this.curveXRangeDegree;
      return this.curveYRangeDegree * function (e, t) {
        if (e.length < 8) throw new Error("evaluateCurve: Invalid curve detected! (Array length must be 8 at least)");
        if (e.length % 4 != 0) throw new Error("evaluateCurve: Invalid curve detected! (Array length must be multiples of 4");
        var n;

        for (n = 0;; n++) {
          if (e.length <= 4 * n) return e[4 * n - 3];
          if (t <= e[4 * n]) break;
        }

        var i = n - 1;
        if (i < 0) return e[4 * i + 5];
        var r = e[4 * i],
            o = (t - r) / (e[4 * n] - r);
        return function (e, t, n, i, r) {
          var o = r * r * r,
              s = r * r;
          return e + (t - e) * (-2 * o + 3 * s) + n * (o - 2 * s + r) + i * (o - s);
        }(e[4 * i + 1], e[4 * n + 1], e[4 * i + 3], e[4 * n + 2], o);
      }(this.curve, t);
    }
  }]);

  return O;
}();

var C = function C() {
  _classCallCheck(this, C);
};

var N = /*#__PURE__*/function (_C) {
  _inherits(N, _C);

  function N(e, t, n, i) {
    var _this13;

    _classCallCheck(this, N);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(N).call(this)), _this13.type = u.FirstPersonLookAtTypeName.BlendShape, _this13._curveHorizontal = t, _this13._curveVerticalDown = n, _this13._curveVerticalUp = i, _this13._blendShapeProxy = e;
    return _this13;
  }

  _createClass(N, [{
    key: "name",
    value: function name() {
      return u.FirstPersonLookAtTypeName.BlendShape;
    }
  }, {
    key: "lookAt",
    value: function lookAt(e) {
      var t = e.x,
          n = e.y;
      t < 0 ? (this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookup, 0), this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookdown, this._curveVerticalDown.map(-t))) : (this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookdown, 0), this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookup, this._curveVerticalUp.map(t))), n < 0 ? (this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookleft, 0), this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookright, this._curveHorizontal.map(-n))) : (this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookright, 0), this._blendShapeProxy.setValue(u.BlendShapePresetName.Lookleft, this._curveHorizontal.map(n)));
    }
  }]);

  return N;
}(C);

var D = Object.freeze(new e.Vector3(0, 0, -1)),
    U = new e.Vector3(),
    V = new e.Vector3(),
    B = new e.Vector3(),
    G = new e.Quaternion();

var H = /*#__PURE__*/function () {
  function H(t, n) {
    _classCallCheck(this, H);

    this.autoUpdate = !0, this._euler = new e.Euler(0, 0, 0, H.EULER_ORDER), this.firstPerson = t, this.applyer = n;
  }

  _createClass(H, [{
    key: "getLookAtWorldDirection",
    value: function getLookAtWorldDirection(e) {
      var t = _(this.firstPerson.firstPersonBone, G);

      return e.copy(D).applyEuler(this._euler).applyQuaternion(t);
    }
  }, {
    key: "lookAt",
    value: function lookAt(e) {
      this._calcEuler(this._euler, e), this.applyer && this.applyer.lookAt(this._euler);
    }
  }, {
    key: "update",
    value: function update(e) {
      this.target && this.autoUpdate && (this.lookAt(this.target.getWorldPosition(U)), this.applyer && this.applyer.lookAt(this._euler));
    }
  }, {
    key: "_calcEuler",
    value: function _calcEuler(e, t) {
      var n = this.firstPerson.getFirstPersonWorldPosition(V),
          i = B.copy(t).sub(n).normalize();
      return i.applyQuaternion(w(_(this.firstPerson.firstPersonBone, G))), e.x = Math.atan2(i.y, Math.sqrt(i.x * i.x + i.z * i.z)), e.y = Math.atan2(-i.x, -i.z), e;
    }
  }]);

  return H;
}();

H.EULER_ORDER = "YXZ";
var F = new e.Euler(0, 0, 0, H.EULER_ORDER);

var k = /*#__PURE__*/function (_C2) {
  _inherits(k, _C2);

  function k(e, t, n, i, r) {
    var _this14;

    _classCallCheck(this, k);

    _this14 = _possibleConstructorReturn(this, _getPrototypeOf(k).call(this)), _this14.type = u.FirstPersonLookAtTypeName.Bone, _this14._curveHorizontalInner = t, _this14._curveHorizontalOuter = n, _this14._curveVerticalDown = i, _this14._curveVerticalUp = r, _this14._leftEye = e.getBoneNode(u.HumanoidBoneName.LeftEye), _this14._rightEye = e.getBoneNode(u.HumanoidBoneName.RightEye);
    return _this14;
  }

  _createClass(k, [{
    key: "lookAt",
    value: function lookAt(e) {
      var t = e.x,
          n = e.y;
      this._leftEye && (F.x = t < 0 ? -this._curveVerticalDown.map(-t) : this._curveVerticalUp.map(t), F.y = n < 0 ? -this._curveHorizontalInner.map(-n) : this._curveHorizontalOuter.map(n), this._leftEye.quaternion.setFromEuler(F)), this._rightEye && (F.x = t < 0 ? -this._curveVerticalDown.map(-t) : this._curveVerticalUp.map(t), F.y = n < 0 ? -this._curveHorizontalOuter.map(-n) : this._curveHorizontalInner.map(n), this._rightEye.quaternion.setFromEuler(F));
    }
  }]);

  return k;
}(C);

var W = Math.PI / 180;

var z = /*#__PURE__*/function () {
  function z() {
    _classCallCheck(this, z);
  }

  _createClass(z, [{
    key: "import",
    value: function _import(e, t, n, i) {
      var r;
      var o = null === (r = e.parser.json.extensions) || void 0 === r ? void 0 : r.VRM;
      if (!o) return null;
      var s = o.firstPerson;
      if (!s) return null;

      var a = this._importApplyer(s, n, i);

      return new H(t, a || void 0);
    }
  }, {
    key: "_importApplyer",
    value: function _importApplyer(e, t, n) {
      var i = e.lookAtHorizontalInner,
          r = e.lookAtHorizontalOuter,
          o = e.lookAtVerticalDown,
          s = e.lookAtVerticalUp;

      switch (e.lookAtTypeName) {
        case u.FirstPersonLookAtTypeName.Bone:
          return void 0 === i || void 0 === r || void 0 === o || void 0 === s ? null : new k(n, this._importCurveMapperBone(i), this._importCurveMapperBone(r), this._importCurveMapperBone(o), this._importCurveMapperBone(s));

        case u.FirstPersonLookAtTypeName.BlendShape:
          return void 0 === r || void 0 === o || void 0 === s ? null : new N(t, this._importCurveMapperBlendShape(r), this._importCurveMapperBlendShape(o), this._importCurveMapperBlendShape(s));

        default:
          return null;
      }
    }
  }, {
    key: "_importCurveMapperBone",
    value: function _importCurveMapperBone(e) {
      return new O("number" == typeof e.xRange ? W * e.xRange : void 0, "number" == typeof e.yRange ? W * e.yRange : void 0, e.curve);
    }
  }, {
    key: "_importCurveMapperBlendShape",
    value: function _importCurveMapperBlendShape(e) {
      return new O("number" == typeof e.xRange ? W * e.xRange : void 0, e.yRange, e.curve);
    }
  }]);

  return z;
}();

var j = '// #define PHONG\n\n#ifdef BLENDMODE_CUTOUT\n  uniform float cutoff;\n#endif\n\nuniform vec3 color;\nuniform float colorAlpha;\nuniform vec3 shadeColor;\n#ifdef USE_SHADETEXTURE\n  uniform sampler2D shadeTexture;\n#endif\n\nuniform float receiveShadowRate;\n#ifdef USE_RECEIVESHADOWTEXTURE\n  uniform sampler2D receiveShadowTexture;\n#endif\n\nuniform float shadingGradeRate;\n#ifdef USE_SHADINGGRADETEXTURE\n  uniform sampler2D shadingGradeTexture;\n#endif\n\nuniform float shadeShift;\nuniform float shadeToony;\nuniform float lightColorAttenuation;\nuniform float indirectLightIntensity;\n\n#ifdef USE_RIMTEXTURE\n  uniform sampler2D rimTexture;\n#endif\nuniform vec3 rimColor;\nuniform float rimLightingMix;\nuniform float rimFresnelPower;\nuniform float rimLift;\n\n#ifdef USE_SPHEREADD\n  uniform sampler2D sphereAdd;\n#endif\n\nuniform vec3 emissionColor;\n\nuniform vec3 outlineColor;\nuniform float outlineLightingMix;\n\n#ifdef USE_UVANIMMASKTEXTURE\n  uniform sampler2D uvAnimMaskTexture;\n#endif\n\nuniform float uvAnimOffsetX;\nuniform float uvAnimOffsetY;\nuniform float uvAnimTheta;\n\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n\n// #include <uv_pars_fragment>\n#if ( defined( MTOON_USE_UV ) && !defined( MTOON_UVS_VERTEX_ONLY ) )\n  varying vec2 vUv;\n#endif\n\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n// #include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n// #include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n// #include <envmap_common_pars_fragment>\n// #include <envmap_pars_fragment>\n// #include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n\n// #include <bsdfs>\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n    return RECIPROCAL_PI * diffuseColor;\n}\n\n#include <lights_pars_begin>\n\n// #include <lights_phong_pars_fragment>\nvarying vec3 vViewPosition;\n\n#ifndef FLAT_SHADED\n  varying vec3 vNormal;\n#endif\n\nstruct MToonMaterial {\n  vec3 diffuseColor;\n  vec3 shadeColor;\n  float shadingGrade;\n  float receiveShadow;\n};\n\n#define Material_LightProbeLOD( material ) (0)\n\n#include <shadowmap_pars_fragment>\n// #include <bumpmap_pars_fragment>\n\n// #include <normalmap_pars_fragment>\n#ifdef USE_NORMALMAP\n\n  uniform sampler2D normalMap;\n  uniform vec2 normalScale;\n\n#endif\n\n#ifdef OBJECTSPACE_NORMALMAP\n\n  uniform mat3 normalMatrix;\n\n#endif\n\n#if ! defined ( USE_TANGENT ) && defined ( TANGENTSPACE_NORMALMAP )\n\n  // Per-Pixel Tangent Space Normal Mapping\n  // http://hacksoflife.blogspot.ch/2009/11/per-pixel-tangent-space-normal-mapping.html\n\n  // three-vrm specific change: it requires `uv` as an input in order to support uv scrolls\n\n  // Temporary compat against shader change @ Three.js r126\n  // See: #21205, #21307, #21299\n  #if THREE_VRM_THREE_REVISION >= 126\n\n    vec3 perturbNormal2Arb( vec2 uv, vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\n      vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n      vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n      vec2 st0 = dFdx( uv.st );\n      vec2 st1 = dFdy( uv.st );\n\n      vec3 N = normalize( surf_norm );\n\n      vec3 q1perp = cross( q1, N );\n      vec3 q0perp = cross( N, q0 );\n\n      vec3 T = q1perp * st0.x + q0perp * st1.x;\n      vec3 B = q1perp * st0.y + q0perp * st1.y;\n\n      // three-vrm specific change: Workaround for the issue that happens when delta of uv = 0.0\n      // TODO: Is this still required? Or shall I make a PR about it?\n      if ( length( T ) == 0.0 || length( B ) == 0.0 ) {\n        return surf_norm;\n      }\n\n      float det = max( dot( T, T ), dot( B, B ) );\n      float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\n      return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\n    }\n\n  #else\n\n    vec3 perturbNormal2Arb( vec2 uv, vec3 eye_pos, vec3 surf_norm, vec3 mapN ) {\n\n      // Workaround for Adreno 3XX dFd*( vec3 ) bug. See #9988\n\n      vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n      vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n      vec2 st0 = dFdx( uv.st );\n      vec2 st1 = dFdy( uv.st );\n\n      float scale = sign( st1.t * st0.s - st0.t * st1.s ); // we do not care about the magnitude\n\n      vec3 S = ( q0 * st1.t - q1 * st0.t ) * scale;\n      vec3 T = ( - q0 * st1.s + q1 * st0.s ) * scale;\n\n      // three-vrm specific change: Workaround for the issue that happens when delta of uv = 0.0\n      // TODO: Is this still required? Or shall I make a PR about it?\n\n      if ( length( S ) == 0.0 || length( T ) == 0.0 ) {\n        return surf_norm;\n      }\n\n      S = normalize( S );\n      T = normalize( T );\n      vec3 N = normalize( surf_norm );\n\n      #ifdef DOUBLE_SIDED\n\n        // Workaround for Adreno GPUs gl_FrontFacing bug. See #15850 and #10331\n\n        bool frontFacing = dot( cross( S, T ), N ) > 0.0;\n\n        mapN.xy *= ( float( frontFacing ) * 2.0 - 1.0 );\n\n      #else\n\n        mapN.xy *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\n      #endif\n\n      mat3 tsn = mat3( S, T, N );\n      return normalize( tsn * mapN );\n\n    }\n\n  #endif\n\n#endif\n\n// #include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\n\n// == lighting stuff ===========================================================\nfloat getLightIntensity(\n  const in IncidentLight directLight,\n  const in GeometricContext geometry,\n  const in float shadow,\n  const in float shadingGrade\n) {\n  float lightIntensity = dot( geometry.normal, directLight.direction );\n  lightIntensity = 0.5 + 0.5 * lightIntensity;\n  lightIntensity = lightIntensity * shadow;\n  lightIntensity = lightIntensity * shadingGrade;\n  lightIntensity = lightIntensity * 2.0 - 1.0;\n  return shadeToony == 1.0\n    ? step( shadeShift, lightIntensity )\n    : smoothstep( shadeShift, shadeShift + ( 1.0 - shadeToony ), lightIntensity );\n}\n\nvec3 getLighting( const in vec3 lightColor ) {\n  vec3 lighting = lightColor;\n  lighting = mix(\n    lighting,\n    vec3( max( 0.001, max( lighting.x, max( lighting.y, lighting.z ) ) ) ),\n    lightColorAttenuation\n  );\n\n  #if THREE_VRM_THREE_REVISION < 132\n    #ifndef PHYSICALLY_CORRECT_LIGHTS\n      lighting *= PI;\n    #endif\n  #endif\n\n  return lighting;\n}\n\nvec3 getDiffuse(\n  const in MToonMaterial material,\n  const in float lightIntensity,\n  const in vec3 lighting\n) {\n  #ifdef DEBUG_LITSHADERATE\n    return vec3( BRDF_Lambert( lightIntensity * lighting ) );\n  #endif\n\n  return lighting * BRDF_Lambert( mix( material.shadeColor, material.diffuseColor, lightIntensity ) );\n}\n\n// == post correction ==========================================================\nvoid postCorrection() {\n  #include <tonemapping_fragment>\n  #include <encodings_fragment>\n  #include <fog_fragment>\n  #include <premultiplied_alpha_fragment>\n  #include <dithering_fragment>\n}\n\n// == main procedure ===========================================================\nvoid main() {\n  #include <clipping_planes_fragment>\n\n  vec2 uv = vec2(0.5, 0.5);\n\n  #if ( defined( MTOON_USE_UV ) && !defined( MTOON_UVS_VERTEX_ONLY ) )\n    uv = vUv;\n\n    float uvAnimMask = 1.0;\n    #ifdef USE_UVANIMMASKTEXTURE\n      uvAnimMask = texture2D( uvAnimMaskTexture, uv ).x;\n    #endif\n\n    uv = uv + vec2( uvAnimOffsetX, uvAnimOffsetY ) * uvAnimMask;\n    float uvRotCos = cos( uvAnimTheta * uvAnimMask );\n    float uvRotSin = sin( uvAnimTheta * uvAnimMask );\n    uv = mat2( uvRotCos, uvRotSin, -uvRotSin, uvRotCos ) * ( uv - 0.5 ) + 0.5;\n  #endif\n\n  #ifdef DEBUG_UV\n    gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n    #if ( defined( MTOON_USE_UV ) && !defined( MTOON_UVS_VERTEX_ONLY ) )\n      gl_FragColor = vec4( uv, 0.0, 1.0 );\n    #endif\n    return;\n  #endif\n\n  vec4 diffuseColor = vec4( color, colorAlpha );\n  ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n  vec3 totalEmissiveRadiance = emissionColor;\n\n  #include <logdepthbuf_fragment>\n\n  // #include <map_fragment>\n  #ifdef USE_MAP\n    #if THREE_VRM_THREE_REVISION >= 137\n      vec4 sampledDiffuseColor = texture2D( map, uv );\n      #ifdef DECODE_VIDEO_TEXTURE\n        sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n      #endif\n      diffuseColor *= sampledDiffuseColor;\n    #else\n      // COMPAT: pre-r137\n      diffuseColor *= mapTexelToLinear( texture2D( map, uv ) );\n    #endif\n  #endif\n\n  #include <color_fragment>\n  // #include <alphamap_fragment>\n\n  // -- MToon: alpha -----------------------------------------------------------\n  // #include <alphatest_fragment>\n  #ifdef BLENDMODE_CUTOUT\n    if ( diffuseColor.a <= cutoff ) { discard; }\n    diffuseColor.a = 1.0;\n  #endif\n\n  #ifdef BLENDMODE_OPAQUE\n    diffuseColor.a = 1.0;\n  #endif\n\n  #if defined( OUTLINE ) && defined( OUTLINE_COLOR_FIXED ) // omitting DebugMode\n    gl_FragColor = vec4( outlineColor, diffuseColor.a );\n    postCorrection();\n    return;\n  #endif\n\n  // #include <specularmap_fragment>\n  #include <normal_fragment_begin>\n\n  #ifdef OUTLINE\n    normal *= -1.0;\n  #endif\n\n  // #include <normal_fragment_maps>\n\n  #ifdef OBJECTSPACE_NORMALMAP\n\n    normal = texture2D( normalMap, uv ).xyz * 2.0 - 1.0; // overrides both flatShading and attribute normals\n\n    #ifdef FLIP_SIDED\n\n      normal = - normal;\n\n    #endif\n\n    #ifdef DOUBLE_SIDED\n\n      // Temporary compat against shader change @ Three.js r126\n      // See: #21205, #21307, #21299\n      #if THREE_VRM_THREE_REVISION >= 126\n\n        normal = normal * faceDirection;\n\n      #else\n\n        normal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\n      #endif\n\n    #endif\n\n    normal = normalize( normalMatrix * normal );\n\n  #elif defined( TANGENTSPACE_NORMALMAP )\n\n    vec3 mapN = texture2D( normalMap, uv ).xyz * 2.0 - 1.0;\n    mapN.xy *= normalScale;\n\n    #ifdef USE_TANGENT\n\n      normal = normalize( vTBN * mapN );\n\n    #else\n\n      // Temporary compat against shader change @ Three.js r126\n      // See: #21205, #21307, #21299\n      #if THREE_VRM_THREE_REVISION >= 126\n\n        normal = perturbNormal2Arb( uv, -vViewPosition, normal, mapN, faceDirection );\n\n      #else\n\n        normal = perturbNormal2Arb( uv, -vViewPosition, normal, mapN );\n\n      #endif\n\n    #endif\n\n  #endif\n\n  // #include <emissivemap_fragment>\n  #ifdef USE_EMISSIVEMAP\n    #if THREE_VRM_THREE_REVISION >= 137\n      totalEmissiveRadiance *= texture2D( emissiveMap, uv ).rgb;\n    #else\n      // COMPAT: pre-r137\n      totalEmissiveRadiance *= emissiveMapTexelToLinear( texture2D( emissiveMap, uv ) ).rgb;\n    #endif\n  #endif\n\n  #ifdef DEBUG_NORMAL\n    gl_FragColor = vec4( 0.5 + 0.5 * normal, 1.0 );\n    return;\n  #endif\n\n  // -- MToon: lighting --------------------------------------------------------\n  // accumulation\n  // #include <lights_phong_fragment>\n  MToonMaterial material;\n\n  material.diffuseColor = diffuseColor.rgb;\n\n  material.shadeColor = shadeColor;\n  #ifdef USE_SHADETEXTURE\n    #if THREE_VRM_THREE_REVISION >= 137\n      material.shadeColor *= texture2D( shadeTexture, uv ).rgb;\n    #else\n      // COMPAT: pre-r137\n      material.shadeColor *= shadeTextureTexelToLinear( texture2D( shadeTexture, uv ) ).rgb;\n    #endif\n  #endif\n\n  material.shadingGrade = 1.0;\n  #ifdef USE_SHADINGGRADETEXTURE\n    material.shadingGrade = 1.0 - shadingGradeRate * ( 1.0 - texture2D( shadingGradeTexture, uv ).r );\n  #endif\n\n  material.receiveShadow = receiveShadowRate;\n  #ifdef USE_RECEIVESHADOWTEXTURE\n    material.receiveShadow *= texture2D( receiveShadowTexture, uv ).a;\n  #endif\n\n  // #include <lights_fragment_begin>\n  GeometricContext geometry;\n\n  geometry.position = - vViewPosition;\n  geometry.normal = normal;\n  geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n\n  IncidentLight directLight;\n  vec3 lightingSum = vec3( 0.0 );\n\n  // since these variables will be used in unrolled loop, we have to define in prior\n  float atten, shadow, lightIntensity;\n  vec3 lighting;\n\n  #if ( NUM_POINT_LIGHTS > 0 )\n    PointLight pointLight;\n\n    #if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n    PointLightShadow pointLightShadow;\n    #endif\n\n    #pragma unroll_loop_start\n    for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n      pointLight = pointLights[ i ];\n\n      #if THREE_VRM_THREE_REVISION >= 132\n        getPointLightInfo( pointLight, geometry, directLight );\n      #else\n        getPointDirectLightIrradiance( pointLight, geometry, directLight );\n      #endif\n\n      atten = 1.0;\n      #if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n      pointLightShadow = pointLightShadows[ i ];\n      atten = all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n      #endif\n\n      shadow = 1.0 - material.receiveShadow * ( 1.0 - ( 0.5 + 0.5 * atten ) );\n      lightIntensity = getLightIntensity( directLight, geometry, shadow, material.shadingGrade );\n      lighting = getLighting( directLight.color );\n      reflectedLight.directDiffuse += getDiffuse( material, lightIntensity, lighting );\n      lightingSum += lighting;\n    }\n    #pragma unroll_loop_end\n  #endif\n\n  #if ( NUM_SPOT_LIGHTS > 0 )\n    SpotLight spotLight;\n\n    #if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n    SpotLightShadow spotLightShadow;\n    #endif\n\n    #pragma unroll_loop_start\n    for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n      spotLight = spotLights[ i ];\n\n      #if THREE_VRM_THREE_REVISION >= 132\n        getSpotLightInfo( spotLight, geometry, directLight );\n      #else\n        getSpotDirectLightIrradiance( spotLight, geometry, directLight );\n      #endif\n\n      atten = 1.0;\n      #if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n      spotLightShadow = spotLightShadows[ i ];\n      atten = all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n      #endif\n\n      shadow = 1.0 - material.receiveShadow * ( 1.0 - ( 0.5 + 0.5 * atten ) );\n      lightIntensity = getLightIntensity( directLight, geometry, shadow, material.shadingGrade );\n      lighting = getLighting( directLight.color );\n      reflectedLight.directDiffuse += getDiffuse( material, lightIntensity, lighting );\n      lightingSum += lighting;\n    }\n    #pragma unroll_loop_end\n  #endif\n\n  #if ( NUM_DIR_LIGHTS > 0 )\n    DirectionalLight directionalLight;\n\n    #if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n    DirectionalLightShadow directionalLightShadow;\n    #endif\n\n    #pragma unroll_loop_start\n    for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n      directionalLight = directionalLights[ i ];\n\n      #if THREE_VRM_THREE_REVISION >= 132\n        getDirectionalLightInfo( directionalLight, geometry, directLight );\n      #else\n        getDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n      #endif\n\n      atten = 1.0;\n      #if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n      directionalLightShadow = directionalLightShadows[ i ];\n      atten = all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n      #endif\n\n      shadow = 1.0 - material.receiveShadow * ( 1.0 - ( 0.5 + 0.5 * atten ) );\n      lightIntensity = getLightIntensity( directLight, geometry, shadow, material.shadingGrade );\n      lighting = getLighting( directLight.color );\n      reflectedLight.directDiffuse += getDiffuse( material, lightIntensity, lighting );\n      lightingSum += lighting;\n    }\n    #pragma unroll_loop_end\n  #endif\n\n  // #if defined( RE_IndirectDiffuse )\n  vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n  #if THREE_VRM_THREE_REVISION >= 133\n    irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n  #else\n    irradiance += getLightProbeIrradiance( lightProbe, geometry );\n  #endif\n  #if ( NUM_HEMI_LIGHTS > 0 )\n    #pragma unroll_loop_start\n    for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n      #if THREE_VRM_THREE_REVISION >= 133\n        irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n      #else\n        irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n      #endif\n    }\n    #pragma unroll_loop_end\n  #endif\n  // #endif\n\n  // #include <lights_fragment_maps>\n  #ifdef USE_LIGHTMAP\n    vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n    #if THREE_VRM_THREE_REVISION >= 137\n      vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n    #else\n      // COMPAT: pre-r137\n      vec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n    #endif\n    #ifndef PHYSICALLY_CORRECT_LIGHTS\n      lightMapIrradiance *= PI;\n    #endif\n    irradiance += lightMapIrradiance;\n  #endif\n\n  // #include <lights_fragment_end>\n  // RE_IndirectDiffuse here\n  reflectedLight.indirectDiffuse += indirectLightIntensity * irradiance * BRDF_Lambert( material.diffuseColor );\n\n  // modulation\n  #include <aomap_fragment>\n\n  vec3 col = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\n  // The "comment out if you want to PBR absolutely" line\n  #ifndef DEBUG_LITSHADERATE\n    col = min(col, material.diffuseColor);\n  #endif\n\n  #if defined( OUTLINE ) && defined( OUTLINE_COLOR_MIXED )\n    gl_FragColor = vec4(\n      outlineColor.rgb * mix( vec3( 1.0 ), col, outlineLightingMix ),\n      diffuseColor.a\n    );\n    postCorrection();\n    return;\n  #endif\n\n  #ifdef DEBUG_LITSHADERATE\n    gl_FragColor = vec4( col, diffuseColor.a );\n    postCorrection();\n    return;\n  #endif\n\n  // -- MToon: parametric rim lighting -----------------------------------------\n  vec3 viewDir = normalize( vViewPosition );\n  vec3 rimMix = mix( vec3( 1.0 ), lightingSum + indirectLightIntensity * irradiance, rimLightingMix );\n  vec3 rim = rimColor * pow( saturate( 1.0 - dot( viewDir, normal ) + rimLift ), rimFresnelPower );\n  #ifdef USE_RIMTEXTURE\n    #if THREE_VRM_THREE_REVISION >= 137\n      rim *= texture2D( rimTexture, uv ).rgb;\n    #else\n      // COMPAT: pre-r137\n      rim *= rimTextureTexelToLinear( texture2D( rimTexture, uv ) ).rgb;\n    #endif\n  #endif\n  col += rim;\n\n  // -- MToon: additive matcap -------------------------------------------------\n  #ifdef USE_SPHEREADD\n    {\n      vec3 x = normalize( vec3( viewDir.z, 0.0, -viewDir.x ) );\n      vec3 y = cross( viewDir, x ); // guaranteed to be normalized\n      vec2 sphereUv = 0.5 + 0.5 * vec2( dot( x, normal ), -dot( y, normal ) );\n      #if THREE_VRM_THREE_REVISION >= 137\n        vec3 matcap = texture2D( sphereAdd, sphereUv ).xyz;\n      #else\n        // COMPAT: pre-r137\n        vec3 matcap = sphereAddTexelToLinear( texture2D( sphereAdd, sphereUv ) ).xyz;\n      #endif\n      col += matcap;\n    }\n  #endif\n\n  // -- MToon: Emission --------------------------------------------------------\n  col += totalEmissiveRadiance;\n\n  // #include <envmap_fragment>\n\n  // -- Almost done! -----------------------------------------------------------\n  gl_FragColor = vec4( col, diffuseColor.a );\n  postCorrection();\n}';

var Y = function Y(t, n) {
  var i = function (t) {
    if (parseInt(e.REVISION, 10) >= 136) switch (t) {
      case e.LinearEncoding:
        return ["Linear", "( value )"];

      case e.sRGBEncoding:
        return ["sRGB", "( value )"];

      default:
        return console.warn("THREE.WebGLProgram: Unsupported encoding:", t), ["Linear", "( value )"];
    } else switch (t) {
      case e.LinearEncoding:
        return ["Linear", "( value )"];

      case e.sRGBEncoding:
        return ["sRGB", "( value )"];

      case 3002:
        return ["RGBE", "( value )"];

      case 3004:
        return ["RGBM", "( value, 7.0 )"];

      case 3005:
        return ["RGBM", "( value, 16.0 )"];

      case 3006:
        return ["RGBD", "( value, 256.0 )"];

      case 3007:
        return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];

      default:
        throw new Error("unsupported encoding: " + t);
    }
  }(n);

  return "vec4 " + t + "( vec4 value ) { return " + i[0] + "ToLinear" + i[1] + "; }";
},
    X = 2 * Math.PI;

var q, Q, Z, $, J;
!function (e) {
  e[e.Off = 0] = "Off", e[e.Front = 1] = "Front", e[e.Back = 2] = "Back";
}(q || (q = {})), function (e) {
  e[e.None = 0] = "None", e[e.Normal = 1] = "Normal", e[e.LitShadeRate = 2] = "LitShadeRate", e[e.UV = 3] = "UV";
}(Q || (Q = {})), function (e) {
  e[e.FixedColor = 0] = "FixedColor", e[e.MixedLighting = 1] = "MixedLighting";
}(Z || (Z = {})), function (e) {
  e[e.None = 0] = "None", e[e.WorldCoordinates = 1] = "WorldCoordinates", e[e.ScreenCoordinates = 2] = "ScreenCoordinates";
}($ || ($ = {})), function (e) {
  e[e.Opaque = 0] = "Opaque", e[e.Cutout = 1] = "Cutout", e[e.Transparent = 2] = "Transparent", e[e.TransparentWithZWrite = 3] = "TransparentWithZWrite";
}(J || (J = {}));

var K = /*#__PURE__*/function (_e$ShaderMaterial) {
  _inherits(K, _e$ShaderMaterial);

  function K() {
    var _this15;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, K);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(K).call(this)), _this15.isMToonMaterial = !0, _this15.cutoff = .5, _this15.color = new e.Vector4(1, 1, 1, 1), _this15.shadeColor = new e.Vector4(.97, .81, .86, 1), _this15.map = null, _this15.mainTex_ST = new e.Vector4(0, 0, 1, 1), _this15.shadeTexture = null, _this15.normalMap = null, _this15.normalMapType = e.TangentSpaceNormalMap, _this15.normalScale = new e.Vector2(1, 1), _this15.receiveShadowRate = 1, _this15.receiveShadowTexture = null, _this15.shadingGradeRate = 1, _this15.shadingGradeTexture = null, _this15.shadeShift = 0, _this15.shadeToony = .9, _this15.lightColorAttenuation = 0, _this15.indirectLightIntensity = .1, _this15.rimTexture = null, _this15.rimColor = new e.Vector4(0, 0, 0, 1), _this15.rimLightingMix = 0, _this15.rimFresnelPower = 1, _this15.rimLift = 0, _this15.sphereAdd = null, _this15.emissionColor = new e.Vector4(0, 0, 0, 1), _this15.emissiveMap = null, _this15.outlineWidthTexture = null, _this15.outlineWidth = .5, _this15.outlineScaledMaxDistance = 1, _this15.outlineColor = new e.Vector4(0, 0, 0, 1), _this15.outlineLightingMix = 1, _this15.uvAnimMaskTexture = null, _this15.uvAnimScrollX = 0, _this15.uvAnimScrollY = 0, _this15.uvAnimRotation = 0, _this15.shouldApplyUniforms = !0, _this15._debugMode = Q.None, _this15._blendMode = J.Opaque, _this15._outlineWidthMode = $.None, _this15._outlineColorMode = Z.FixedColor, _this15._cullMode = q.Back, _this15._outlineCullMode = q.Front, _this15._isOutline = !1, _this15._uvAnimOffsetX = 0, _this15._uvAnimOffsetY = 0, _this15._uvAnimPhase = 0, _this15.encoding = t.encoding || e.LinearEncoding, _this15.encoding !== e.LinearEncoding && _this15.encoding !== e.sRGBEncoding && console.warn("The specified color encoding does not work properly with MToonMaterial. You might want to use THREE.sRGBEncoding instead."), ["mToonVersion", "shadeTexture_ST", "bumpMap_ST", "receiveShadowTexture_ST", "shadingGradeTexture_ST", "rimTexture_ST", "sphereAdd_ST", "emissionMap_ST", "outlineWidthTexture_ST", "uvAnimMaskTexture_ST", "srcBlend", "dstBlend"].forEach(function (e) {
      void 0 !== t[e] && delete t[e];
    }), t.fog = !0, t.lights = !0, t.clipping = !0, parseInt(e.REVISION, 10) < 129 && (t.skinning = t.skinning || !1), parseInt(e.REVISION, 10) < 131 && (t.morphTargets = t.morphTargets || !1, t.morphNormals = t.morphNormals || !1), t.uniforms = e.UniformsUtils.merge([e.UniformsLib.common, e.UniformsLib.normalmap, e.UniformsLib.emissivemap, e.UniformsLib.fog, e.UniformsLib.lights, {
      cutoff: {
        value: .5
      },
      color: {
        value: new e.Color(1, 1, 1)
      },
      colorAlpha: {
        value: 1
      },
      shadeColor: {
        value: new e.Color(.97, .81, .86)
      },
      mainTex_ST: {
        value: new e.Vector4(0, 0, 1, 1)
      },
      shadeTexture: {
        value: null
      },
      receiveShadowRate: {
        value: 1
      },
      receiveShadowTexture: {
        value: null
      },
      shadingGradeRate: {
        value: 1
      },
      shadingGradeTexture: {
        value: null
      },
      shadeShift: {
        value: 0
      },
      shadeToony: {
        value: .9
      },
      lightColorAttenuation: {
        value: 0
      },
      indirectLightIntensity: {
        value: .1
      },
      rimTexture: {
        value: null
      },
      rimColor: {
        value: new e.Color(0, 0, 0)
      },
      rimLightingMix: {
        value: 0
      },
      rimFresnelPower: {
        value: 1
      },
      rimLift: {
        value: 0
      },
      sphereAdd: {
        value: null
      },
      emissionColor: {
        value: new e.Color(0, 0, 0)
      },
      outlineWidthTexture: {
        value: null
      },
      outlineWidth: {
        value: .5
      },
      outlineScaledMaxDistance: {
        value: 1
      },
      outlineColor: {
        value: new e.Color(0, 0, 0)
      },
      outlineLightingMix: {
        value: 1
      },
      uvAnimMaskTexture: {
        value: null
      },
      uvAnimOffsetX: {
        value: 0
      },
      uvAnimOffsetY: {
        value: 0
      },
      uvAnimTheta: {
        value: 0
      }
    }]), _this15.setValues(t), _this15._updateShaderCode(), _this15._applyUniforms();
    return _this15;
  }

  _createClass(K, [{
    key: "updateVRMMaterials",
    value: function updateVRMMaterials(e) {
      this._uvAnimOffsetX = this._uvAnimOffsetX + e * this.uvAnimScrollX, this._uvAnimOffsetY = this._uvAnimOffsetY - e * this.uvAnimScrollY, this._uvAnimPhase = this._uvAnimPhase + e * this.uvAnimRotation, this._applyUniforms();
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return _get(_getPrototypeOf(K.prototype), "copy", this).call(this, e), this.cutoff = e.cutoff, this.color.copy(e.color), this.shadeColor.copy(e.shadeColor), this.map = e.map, this.mainTex_ST.copy(e.mainTex_ST), this.shadeTexture = e.shadeTexture, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(this.normalScale), this.receiveShadowRate = e.receiveShadowRate, this.receiveShadowTexture = e.receiveShadowTexture, this.shadingGradeRate = e.shadingGradeRate, this.shadingGradeTexture = e.shadingGradeTexture, this.shadeShift = e.shadeShift, this.shadeToony = e.shadeToony, this.lightColorAttenuation = e.lightColorAttenuation, this.indirectLightIntensity = e.indirectLightIntensity, this.rimTexture = e.rimTexture, this.rimColor.copy(e.rimColor), this.rimLightingMix = e.rimLightingMix, this.rimFresnelPower = e.rimFresnelPower, this.rimLift = e.rimLift, this.sphereAdd = e.sphereAdd, this.emissionColor.copy(e.emissionColor), this.emissiveMap = e.emissiveMap, this.outlineWidthTexture = e.outlineWidthTexture, this.outlineWidth = e.outlineWidth, this.outlineScaledMaxDistance = e.outlineScaledMaxDistance, this.outlineColor.copy(e.outlineColor), this.outlineLightingMix = e.outlineLightingMix, this.uvAnimMaskTexture = e.uvAnimMaskTexture, this.uvAnimScrollX = e.uvAnimScrollX, this.uvAnimScrollY = e.uvAnimScrollY, this.uvAnimRotation = e.uvAnimRotation, this.debugMode = e.debugMode, this.blendMode = e.blendMode, this.outlineWidthMode = e.outlineWidthMode, this.outlineColorMode = e.outlineColorMode, this.cullMode = e.cullMode, this.outlineCullMode = e.outlineCullMode, this.isOutline = e.isOutline, this;
    }
  }, {
    key: "_applyUniforms",
    value: function _applyUniforms() {
      this.uniforms.uvAnimOffsetX.value = this._uvAnimOffsetX, this.uniforms.uvAnimOffsetY.value = this._uvAnimOffsetY, this.uniforms.uvAnimTheta.value = X * this._uvAnimPhase, this.shouldApplyUniforms && (this.shouldApplyUniforms = !1, this.uniforms.cutoff.value = this.cutoff, this.uniforms.color.value.setRGB(this.color.x, this.color.y, this.color.z), this.uniforms.colorAlpha.value = this.color.w, this.uniforms.shadeColor.value.setRGB(this.shadeColor.x, this.shadeColor.y, this.shadeColor.z), this.uniforms.map.value = this.map, this.uniforms.mainTex_ST.value.copy(this.mainTex_ST), this.uniforms.shadeTexture.value = this.shadeTexture, this.uniforms.normalMap.value = this.normalMap, this.uniforms.normalScale.value.copy(this.normalScale), this.uniforms.receiveShadowRate.value = this.receiveShadowRate, this.uniforms.receiveShadowTexture.value = this.receiveShadowTexture, this.uniforms.shadingGradeRate.value = this.shadingGradeRate, this.uniforms.shadingGradeTexture.value = this.shadingGradeTexture, this.uniforms.shadeShift.value = this.shadeShift, this.uniforms.shadeToony.value = this.shadeToony, this.uniforms.lightColorAttenuation.value = this.lightColorAttenuation, this.uniforms.indirectLightIntensity.value = this.indirectLightIntensity, this.uniforms.rimTexture.value = this.rimTexture, this.uniforms.rimColor.value.setRGB(this.rimColor.x, this.rimColor.y, this.rimColor.z), this.uniforms.rimLightingMix.value = this.rimLightingMix, this.uniforms.rimFresnelPower.value = this.rimFresnelPower, this.uniforms.rimLift.value = this.rimLift, this.uniforms.sphereAdd.value = this.sphereAdd, this.uniforms.emissionColor.value.setRGB(this.emissionColor.x, this.emissionColor.y, this.emissionColor.z), this.uniforms.emissiveMap.value = this.emissiveMap, this.uniforms.outlineWidthTexture.value = this.outlineWidthTexture, this.uniforms.outlineWidth.value = this.outlineWidth, this.uniforms.outlineScaledMaxDistance.value = this.outlineScaledMaxDistance, this.uniforms.outlineColor.value.setRGB(this.outlineColor.x, this.outlineColor.y, this.outlineColor.z), this.uniforms.outlineLightingMix.value = this.outlineLightingMix, this.uniforms.uvAnimMaskTexture.value = this.uvAnimMaskTexture, this.encoding === e.sRGBEncoding && (this.uniforms.color.value.convertSRGBToLinear(), this.uniforms.shadeColor.value.convertSRGBToLinear(), this.uniforms.rimColor.value.convertSRGBToLinear(), this.uniforms.emissionColor.value.convertSRGBToLinear(), this.uniforms.outlineColor.value.convertSRGBToLinear()), this._updateCullFace());
    }
  }, {
    key: "_updateShaderCode",
    value: function _updateShaderCode() {
      var t = null !== this.outlineWidthTexture,
          n = null !== this.map || null !== this.shadeTexture || null !== this.receiveShadowTexture || null !== this.shadingGradeTexture || null !== this.rimTexture || null !== this.uvAnimMaskTexture;

      if (this.defines = {
        THREE_VRM_THREE_REVISION: parseInt(e.REVISION, 10),
        OUTLINE: this._isOutline,
        BLENDMODE_OPAQUE: this._blendMode === J.Opaque,
        BLENDMODE_CUTOUT: this._blendMode === J.Cutout,
        BLENDMODE_TRANSPARENT: this._blendMode === J.Transparent || this._blendMode === J.TransparentWithZWrite,
        MTOON_USE_UV: t || n,
        MTOON_UVS_VERTEX_ONLY: t && !n,
        USE_SHADETEXTURE: null !== this.shadeTexture,
        USE_RECEIVESHADOWTEXTURE: null !== this.receiveShadowTexture,
        USE_SHADINGGRADETEXTURE: null !== this.shadingGradeTexture,
        USE_RIMTEXTURE: null !== this.rimTexture,
        USE_SPHEREADD: null !== this.sphereAdd,
        USE_OUTLINEWIDTHTEXTURE: null !== this.outlineWidthTexture,
        USE_UVANIMMASKTEXTURE: null !== this.uvAnimMaskTexture,
        DEBUG_NORMAL: this._debugMode === Q.Normal,
        DEBUG_LITSHADERATE: this._debugMode === Q.LitShadeRate,
        DEBUG_UV: this._debugMode === Q.UV,
        OUTLINE_WIDTH_WORLD: this._outlineWidthMode === $.WorldCoordinates,
        OUTLINE_WIDTH_SCREEN: this._outlineWidthMode === $.ScreenCoordinates,
        OUTLINE_COLOR_FIXED: this._outlineColorMode === Z.FixedColor,
        OUTLINE_COLOR_MIXED: this._outlineColorMode === Z.MixedLighting
      }, this.vertexShader = "// #define PHONG\n\nvarying vec3 vViewPosition;\n\n#ifndef FLAT_SHADED\n  varying vec3 vNormal;\n#endif\n\n#include <common>\n\n// #include <uv_pars_vertex>\n#ifdef MTOON_USE_UV\n  #ifdef MTOON_UVS_VERTEX_ONLY\n    vec2 vUv;\n  #else\n    varying vec2 vUv;\n  #endif\n\n  uniform vec4 mainTex_ST;\n#endif\n\n#include <uv2_pars_vertex>\n// #include <displacementmap_pars_vertex>\n// #include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n\n#ifdef USE_OUTLINEWIDTHTEXTURE\n  uniform sampler2D outlineWidthTexture;\n#endif\n\nuniform float outlineWidth;\nuniform float outlineScaledMaxDistance;\n\nvoid main() {\n\n  // #include <uv_vertex>\n  #ifdef MTOON_USE_UV\n    vUv = uv;\n    vUv.y = 1.0 - vUv.y; // uv.y is opposite from UniVRM's\n    vUv = mainTex_ST.st + mainTex_ST.pq * vUv;\n    vUv.y = 1.0 - vUv.y; // reverting the previous flip\n  #endif\n\n  #include <uv2_vertex>\n  #include <color_vertex>\n\n  #include <beginnormal_vertex>\n  #include <morphnormal_vertex>\n  #include <skinbase_vertex>\n  #include <skinnormal_vertex>\n\n  // we need this to compute the outline properly\n  objectNormal = normalize( objectNormal );\n\n  #include <defaultnormal_vertex>\n\n  #ifndef FLAT_SHADED // Normal computed with derivatives when FLAT_SHADED\n    vNormal = normalize( transformedNormal );\n  #endif\n\n  #include <begin_vertex>\n\n  #include <morphtarget_vertex>\n  #include <skinning_vertex>\n  // #include <displacementmap_vertex>\n  #include <project_vertex>\n  #include <logdepthbuf_vertex>\n  #include <clipping_planes_vertex>\n\n  vViewPosition = - mvPosition.xyz;\n\n  float outlineTex = 1.0;\n\n  #ifdef OUTLINE\n    #ifdef USE_OUTLINEWIDTHTEXTURE\n      outlineTex = texture2D( outlineWidthTexture, vUv ).r;\n    #endif\n\n    #ifdef OUTLINE_WIDTH_WORLD\n      float worldNormalLength = length( transformedNormal );\n      vec3 outlineOffset = 0.01 * outlineWidth * outlineTex * worldNormalLength * objectNormal;\n      gl_Position = projectionMatrix * modelViewMatrix * vec4( outlineOffset + transformed, 1.0 );\n    #endif\n\n    #ifdef OUTLINE_WIDTH_SCREEN\n      vec3 clipNormal = ( projectionMatrix * modelViewMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n      vec2 projectedNormal = normalize( clipNormal.xy );\n      projectedNormal *= min( gl_Position.w, outlineScaledMaxDistance );\n      projectedNormal.x *= projectionMatrix[ 0 ].x / projectionMatrix[ 1 ].y;\n      gl_Position.xy += 0.01 * outlineWidth * outlineTex * projectedNormal.xy;\n    #endif\n\n    gl_Position.z += 1E-6 * gl_Position.w; // anti-artifact magic\n  #endif\n\n  #include <worldpos_vertex>\n  // #include <envmap_vertex>\n  #include <shadowmap_vertex>\n  #include <fog_vertex>\n\n}", this.fragmentShader = j, parseInt(e.REVISION, 10) < 137) {
        var _e5 = (null !== this.shadeTexture ? Y("shadeTextureTexelToLinear", this.shadeTexture.encoding) + "\n" : "") + (null !== this.sphereAdd ? Y("sphereAddTexelToLinear", this.sphereAdd.encoding) + "\n" : "") + (null !== this.rimTexture ? Y("rimTextureTexelToLinear", this.rimTexture.encoding) + "\n" : "");

        this.fragmentShader = _e5 + j;
      }

      this.needsUpdate = !0;
    }
  }, {
    key: "_updateCullFace",
    value: function _updateCullFace() {
      this.isOutline ? this.outlineCullMode === q.Off ? this.side = e.DoubleSide : this.outlineCullMode === q.Front ? this.side = e.BackSide : this.outlineCullMode === q.Back && (this.side = e.FrontSide) : this.cullMode === q.Off ? this.side = e.DoubleSide : this.cullMode === q.Front ? this.side = e.BackSide : this.cullMode === q.Back && (this.side = e.FrontSide);
    }
  }, {
    key: "mainTex",
    get: function get() {
      return this.map;
    },
    set: function set(e) {
      this.map = e;
    }
  }, {
    key: "bumpMap",
    get: function get() {
      return this.normalMap;
    },
    set: function set(e) {
      this.normalMap = e;
    }
  }, {
    key: "bumpScale",
    get: function get() {
      return this.normalScale.x;
    },
    set: function set(e) {
      this.normalScale.set(e, e);
    }
  }, {
    key: "emissionMap",
    get: function get() {
      return this.emissiveMap;
    },
    set: function set(e) {
      this.emissiveMap = e;
    }
  }, {
    key: "blendMode",
    get: function get() {
      return this._blendMode;
    },
    set: function set(e) {
      this._blendMode = e, this.depthWrite = this._blendMode !== J.Transparent, this.transparent = this._blendMode === J.Transparent || this._blendMode === J.TransparentWithZWrite, this._updateShaderCode();
    }
  }, {
    key: "debugMode",
    get: function get() {
      return this._debugMode;
    },
    set: function set(e) {
      this._debugMode = e, this._updateShaderCode();
    }
  }, {
    key: "outlineWidthMode",
    get: function get() {
      return this._outlineWidthMode;
    },
    set: function set(e) {
      this._outlineWidthMode = e, this._updateShaderCode();
    }
  }, {
    key: "outlineColorMode",
    get: function get() {
      return this._outlineColorMode;
    },
    set: function set(e) {
      this._outlineColorMode = e, this._updateShaderCode();
    }
  }, {
    key: "cullMode",
    get: function get() {
      return this._cullMode;
    },
    set: function set(e) {
      this._cullMode = e, this._updateCullFace();
    }
  }, {
    key: "outlineCullMode",
    get: function get() {
      return this._outlineCullMode;
    },
    set: function set(e) {
      this._outlineCullMode = e, this._updateCullFace();
    }
  }, {
    key: "zWrite",
    get: function get() {
      return this.depthWrite ? 1 : 0;
    },
    set: function set(e) {
      this.depthWrite = .5 <= e;
    }
  }, {
    key: "isOutline",
    get: function get() {
      return this._isOutline;
    },
    set: function set(e) {
      this._isOutline = e, this._updateShaderCode(), this._updateCullFace();
    }
  }]);

  return K;
}(e.ShaderMaterial);

var ee;
!function (e) {
  e[e.Opaque = 0] = "Opaque", e[e.Cutout = 1] = "Cutout", e[e.Transparent = 2] = "Transparent", e[e.TransparentWithZWrite = 3] = "TransparentWithZWrite";
}(ee || (ee = {}));

var te = /*#__PURE__*/function (_e$ShaderMaterial2) {
  _inherits(te, _e$ShaderMaterial2);

  function te(t) {
    var _this16;

    _classCallCheck(this, te);

    _this16 = _possibleConstructorReturn(this, _getPrototypeOf(te).call(this)), _this16.isVRMUnlitMaterial = !0, _this16.cutoff = .5, _this16.map = null, _this16.mainTex_ST = new e.Vector4(0, 0, 1, 1), _this16._renderType = ee.Opaque, _this16.shouldApplyUniforms = !0, void 0 === t && (t = {}), t.fog = !0, t.clipping = !0, parseInt(e.REVISION, 10) < 129 && (t.skinning = t.skinning || !1), parseInt(e.REVISION, 10) < 131 && (t.morphTargets = t.morphTargets || !1, t.morphNormals = t.morphNormals || !1), t.uniforms = e.UniformsUtils.merge([e.UniformsLib.common, e.UniformsLib.fog, {
      cutoff: {
        value: .5
      },
      mainTex_ST: {
        value: new e.Vector4(0, 0, 1, 1)
      }
    }]), _this16.setValues(t), _this16._updateShaderCode(), _this16._applyUniforms();
    return _this16;
  }

  _createClass(te, [{
    key: "updateVRMMaterials",
    value: function updateVRMMaterials(e) {
      this._applyUniforms();
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return _get(_getPrototypeOf(te.prototype), "copy", this).call(this, e), this.cutoff = e.cutoff, this.map = e.map, this.mainTex_ST.copy(e.mainTex_ST), this.renderType = e.renderType, this;
    }
  }, {
    key: "_applyUniforms",
    value: function _applyUniforms() {
      this.shouldApplyUniforms && (this.shouldApplyUniforms = !1, this.uniforms.cutoff.value = this.cutoff, this.uniforms.map.value = this.map, this.uniforms.mainTex_ST.value.copy(this.mainTex_ST));
    }
  }, {
    key: "_updateShaderCode",
    value: function _updateShaderCode() {
      this.defines = {
        RENDERTYPE_OPAQUE: this._renderType === ee.Opaque,
        RENDERTYPE_CUTOUT: this._renderType === ee.Cutout,
        RENDERTYPE_TRANSPARENT: this._renderType === ee.Transparent || this._renderType === ee.TransparentWithZWrite
      }, this.vertexShader = "#include <common>\n\n// #include <uv_pars_vertex>\n#ifdef USE_MAP\n  varying vec2 vUv;\n  uniform vec4 mainTex_ST;\n#endif\n\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n\nvoid main() {\n\n  // #include <uv_vertex>\n  #ifdef USE_MAP\n    vUv = vec2( mainTex_ST.p * uv.x + mainTex_ST.s, mainTex_ST.q * uv.y + mainTex_ST.t );\n  #endif\n\n  #include <uv2_vertex>\n  #include <color_vertex>\n  #include <skinbase_vertex>\n\n  #ifdef USE_ENVMAP\n\n  #include <beginnormal_vertex>\n  #include <morphnormal_vertex>\n  #include <skinnormal_vertex>\n  #include <defaultnormal_vertex>\n\n  #endif\n\n  #include <begin_vertex>\n  #include <morphtarget_vertex>\n  #include <skinning_vertex>\n  #include <project_vertex>\n  #include <logdepthbuf_vertex>\n\n  #include <worldpos_vertex>\n  #include <clipping_planes_vertex>\n  #include <envmap_vertex>\n  #include <fog_vertex>\n\n}", this.fragmentShader = "#ifdef RENDERTYPE_CUTOUT\n  uniform float cutoff;\n#endif\n\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n// #include <alphamap_pars_fragment>\n// #include <aomap_pars_fragment>\n// #include <lightmap_pars_fragment>\n// #include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n// #include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\n\n// == main procedure ===========================================================\nvoid main() {\n  #include <clipping_planes_fragment>\n\n  vec4 diffuseColor = vec4( 1.0 );\n\n  #include <logdepthbuf_fragment>\n\n  #include <map_fragment>\n  #include <color_fragment>\n  // #include <alphamap_fragment>\n\n  // MToon: alpha\n  // #include <alphatest_fragment>\n  #ifdef RENDERTYPE_CUTOUT\n    if ( diffuseColor.a <= cutoff ) { discard; }\n    diffuseColor.a = 1.0;\n  #endif\n\n  #ifdef RENDERTYPE_OPAQUE\n    diffuseColor.a = 1.0;\n  #endif\n\n  // #include <specularmap_fragment>\n\n  ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\n  // accumulation (baked indirect lighting only)\n  #ifdef USE_LIGHTMAP\n    reflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n  #else\n    reflectedLight.indirectDiffuse += vec3( 1.0 );\n  #endif\n\n  // modulation\n  // #include <aomap_fragment>\n\n  reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n  vec3 outgoingLight = reflectedLight.indirectDiffuse;\n\n  // #include <envmap_fragment>\n\n  gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\n  #include <premultiplied_alpha_fragment>\n  #include <tonemapping_fragment>\n  #include <encodings_fragment>\n  #include <fog_fragment>\n}", this.needsUpdate = !0;
    }
  }, {
    key: "mainTex",
    get: function get() {
      return this.map;
    },
    set: function set(e) {
      this.map = e;
    }
  }, {
    key: "renderType",
    get: function get() {
      return this._renderType;
    },
    set: function set(e) {
      this._renderType = e, this.depthWrite = this._renderType !== ee.Transparent, this.transparent = this._renderType === ee.Transparent || this._renderType === ee.TransparentWithZWrite, this._updateShaderCode();
    }
  }]);

  return te;
}(e.ShaderMaterial);

var ne = /*#__PURE__*/function () {
  function ne() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ne);

    this._encoding = t.encoding || e.LinearEncoding, this._encoding !== e.LinearEncoding && this._encoding !== e.sRGBEncoding && console.warn("The specified color encoding might not work properly with VRMMaterialImporter. You might want to use THREE.sRGBEncoding instead."), this._requestEnvMap = t.requestEnvMap;
  }

  _createClass(ne, [{
    key: "convertGLTFMaterials",
    value: function convertGLTFMaterials(e) {
      var t;
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this17 = this;

        var i, r, o, s, a;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                i = null === (t = e.parser.json.extensions) || void 0 === t ? void 0 : t.VRM;

                if (i) {
                  _context12.next = 3;
                  break;
                }

                return _context12.abrupt("return", null);

              case 3:
                r = i.materialProperties;

                if (r) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt("return", null);

              case 6:
                _context12.next = 8;
                return p(e);

              case 8:
                o = _context12.sent;
                s = {};
                a = [];
                _context12.next = 13;
                return Promise.all(Array.from(o.entries()).map(function (_ref6) {
                  var _ref7 = _slicedToArray(_ref6, 2),
                      t = _ref7[0],
                      i = _ref7[1];

                  return n(_this17, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                    var _this18 = this;

                    var o, l;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            o = e.parser.json.nodes[t], l = e.parser.json.meshes[o.mesh];
                            _context11.next = 3;
                            return Promise.all(i.map(function (t, i) {
                              return n(_this18, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                                var n, o, d, h, u, c;
                                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                                  while (1) {
                                    switch (_context10.prev = _context10.next) {
                                      case 0:
                                        n = l.primitives[i];

                                        if (n) {
                                          _context10.next = 3;
                                          break;
                                        }

                                        return _context10.abrupt("return");

                                      case 3:
                                        o = t.geometry, d = o.index ? o.index.count : o.attributes.position.count / 3;
                                        Array.isArray(t.material) || (t.material = [t.material], o.addGroup(0, d, 0));
                                        h = n.material;
                                        c = r[h];
                                        c || (console.warn("VRMMaterialImporter: There are no material definition for material #".concat(h, " on VRM extension.")), c = {
                                          shader: "VRM_USE_GLTFSHADER"
                                        });

                                        if (!s[h]) {
                                          _context10.next = 12;
                                          break;
                                        }

                                        u = s[h];
                                        _context10.next = 18;
                                        break;

                                      case 12:
                                        _context10.next = 14;
                                        return this.createVRMMaterials(t.material[0], c, e);

                                      case 14:
                                        u = _context10.sent;
                                        s[h] = u;
                                        a.push(u.surface);
                                        u.outline && a.push(u.outline);

                                      case 18:
                                        t.material[0] = u.surface;
                                        this._requestEnvMap && u.surface.isMeshStandardMaterial && this._requestEnvMap().then(function (e) {
                                          u.surface.envMap = e, u.surface.needsUpdate = !0;
                                        });
                                        t.renderOrder = c.renderQueue || 2e3;
                                        u.outline && (t.material[1] = u.outline, o.addGroup(0, d, 1));

                                      case 22:
                                      case "end":
                                        return _context10.stop();
                                    }
                                  }
                                }, _callee10, this);
                              }));
                            }));

                          case 3:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11);
                  }));
                }));

              case 13:
                return _context12.abrupt("return", a);

              case 14:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    }
  }, {
    key: "createVRMMaterials",
    value: function createVRMMaterials(e, t, i) {
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _this19 = this;

        var n, r, _o2, _r, _r2, _r3, _r4;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!("VRM/MToon" === t.shader)) {
                  _context13.next = 7;
                  break;
                }

                _context13.next = 3;
                return this._extractMaterialProperties(e, t, i);

              case 3:
                _o2 = _context13.sent;
                ["srcBlend", "dstBlend", "isFirstSetup"].forEach(function (e) {
                  void 0 !== _o2[e] && delete _o2[e];
                }), ["mainTex", "shadeTexture", "emissionMap", "sphereAdd", "rimTexture"].forEach(function (e) {
                  void 0 !== _o2[e] && (_o2[e].encoding = _this19._encoding);
                }), _o2.encoding = this._encoding, n = new K(_o2), _o2.outlineWidthMode !== $.None && (_o2.isOutline = !0, r = new K(_o2));
                _context13.next = 36;
                break;

              case 7:
                if (!("VRM/UnlitTexture" === t.shader)) {
                  _context13.next = 14;
                  break;
                }

                _context13.next = 10;
                return this._extractMaterialProperties(e, t, i);

              case 10:
                _r = _context13.sent;
                _r.renderType = ee.Opaque, n = new te(_r);
                _context13.next = 36;
                break;

              case 14:
                if (!("VRM/UnlitCutout" === t.shader)) {
                  _context13.next = 21;
                  break;
                }

                _context13.next = 17;
                return this._extractMaterialProperties(e, t, i);

              case 17:
                _r2 = _context13.sent;
                _r2.renderType = ee.Cutout, n = new te(_r2);
                _context13.next = 36;
                break;

              case 21:
                if (!("VRM/UnlitTransparent" === t.shader)) {
                  _context13.next = 28;
                  break;
                }

                _context13.next = 24;
                return this._extractMaterialProperties(e, t, i);

              case 24:
                _r3 = _context13.sent;
                _r3.renderType = ee.Transparent, n = new te(_r3);
                _context13.next = 36;
                break;

              case 28:
                if (!("VRM/UnlitTransparentZWrite" === t.shader)) {
                  _context13.next = 35;
                  break;
                }

                _context13.next = 31;
                return this._extractMaterialProperties(e, t, i);

              case 31:
                _r4 = _context13.sent;
                _r4.renderType = ee.TransparentWithZWrite, n = new te(_r4);
                _context13.next = 36;
                break;

              case 35:
                "VRM_USE_GLTFSHADER" !== t.shader && console.warn("Unknown shader detected: \"".concat(t.shader, "\"")), n = this._convertGLTFMaterial(e.clone());

              case 36:
                return _context13.abrupt("return", (n.name = e.name, n.userData = JSON.parse(JSON.stringify(e.userData)), n.userData.vrmMaterialProperties = t, r && (r.name = e.name + " (Outline)", r.userData = JSON.parse(JSON.stringify(e.userData)), r.userData.vrmMaterialProperties = t), {
                  surface: n,
                  outline: r
                }));

              case 37:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "_renameMaterialProperty",
    value: function _renameMaterialProperty(e) {
      return "_" !== e[0] ? (console.warn("VRMMaterials: Given property name \"".concat(e, "\" might be invalid")), e) : (e = e.substring(1), /[A-Z]/.test(e[0]) ? e[0].toLowerCase() + e.substring(1) : (console.warn("VRMMaterials: Given property name \"".concat(e, "\" might be invalid")), e));
    }
  }, {
    key: "_convertGLTFMaterial",
    value: function _convertGLTFMaterial(t) {
      if (t.isMeshStandardMaterial) {
        var n = t;
        n.map && (n.map.encoding = this._encoding), n.emissiveMap && (n.emissiveMap.encoding = this._encoding), this._encoding === e.LinearEncoding && (n.color.convertLinearToSRGB(), n.emissive.convertLinearToSRGB());
      }

      if (t.isMeshBasicMaterial) {
        var _n6 = t;
        _n6.map && (_n6.map.encoding = this._encoding), this._encoding === e.LinearEncoding && _n6.color.convertLinearToSRGB();
      }

      return t;
    }
  }, {
    key: "_extractMaterialProperties",
    value: function _extractMaterialProperties(t, n, i) {
      var _this20 = this;

      var r = [],
          o = {};

      if (n.textureProperties) {
        var _loop = function _loop() {
          var e = _Object$keys[_i2];

          var t = _this20._renameMaterialProperty(e),
              s = n.textureProperties[e];

          r.push(i.parser.getDependency("texture", s).then(function (e) {
            o[t] = e;
          }));
        };

        for (var _i2 = 0, _Object$keys = Object.keys(n.textureProperties); _i2 < _Object$keys.length; _i2++) {
          _loop();
        }
      }

      if (n.floatProperties) for (var _i3 = 0, _Object$keys2 = Object.keys(n.floatProperties); _i3 < _Object$keys2.length; _i3++) {
        var _e6 = _Object$keys2[_i3];

        var _t7 = this._renameMaterialProperty(_e6);

        o[_t7] = n.floatProperties[_e6];
      }

      if (n.vectorProperties) {
        var _loop2 = function _loop2() {
          var t = _Object$keys3[_i4];

          var i = _this20._renameMaterialProperty(t);

          ["_MainTex", "_ShadeTexture", "_BumpMap", "_ReceiveShadowTexture", "_ShadingGradeTexture", "_RimTexture", "_SphereAdd", "_EmissionMap", "_OutlineWidthTexture", "_UvAnimMaskTexture"].some(function (e) {
            return t === e;
          }) && (i += "_ST"), o[i] = _construct(e.Vector4, _toConsumableArray(n.vectorProperties[t]));
        };

        for (var _i4 = 0, _Object$keys3 = Object.keys(n.vectorProperties); _i4 < _Object$keys3.length; _i4++) {
          _loop2();
        }
      }

      return parseInt(e.REVISION, 10) < 129 && (o.skinning = t.skinning || !1), parseInt(e.REVISION, 10) < 131 && (o.morphTargets = t.morphTargets || !1, o.morphNormals = t.morphNormals || !1), Promise.all(r).then(function () {
        return o;
      });
    }
  }]);

  return ne;
}();

var ie = /*#__PURE__*/function () {
  function ie(e) {
    _classCallCheck(this, ie);

    var t;
    this.ignoreTexture = null !== (t = null == e ? void 0 : e.ignoreTexture) && void 0 !== t && t;
  }

  _createClass(ie, [{
    key: "import",
    value: function _import(e) {
      var t;
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var n, i, r;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                n = null === (t = e.parser.json.extensions) || void 0 === t ? void 0 : t.VRM;

                if (n) {
                  _context14.next = 3;
                  break;
                }

                return _context14.abrupt("return", null);

              case 3:
                i = n.meta;

                if (i) {
                  _context14.next = 6;
                  break;
                }

                return _context14.abrupt("return", null);

              case 6:
                _context14.t0 = this.ignoreTexture || null == i.texture || -1 === i.texture;

                if (_context14.t0) {
                  _context14.next = 11;
                  break;
                }

                _context14.next = 10;
                return e.parser.getDependency("texture", i.texture);

              case 10:
                r = _context14.sent;

              case 11:
                return _context14.abrupt("return", {
                  allowedUserName: i.allowedUserName,
                  author: i.author,
                  commercialUssageName: i.commercialUssageName,
                  contactInformation: i.contactInformation,
                  licenseName: i.licenseName,
                  otherLicenseUrl: i.otherLicenseUrl,
                  otherPermissionUrl: i.otherPermissionUrl,
                  reference: i.reference,
                  sexualUssageName: i.sexualUssageName,
                  texture: null != r ? r : void 0,
                  title: i.title,
                  version: i.version,
                  violentUssageName: i.violentUssageName
                });

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }]);

  return ie;
}();

var re = new e.Matrix4();

function oe(e) {
  return e.invert ? e.invert() : e.getInverse(re.copy(e)), e;
}

var se = /*#__PURE__*/function () {
  function se(t) {
    var _this21 = this;

    _classCallCheck(this, se);

    this._inverseCache = new e.Matrix4(), this._shouldUpdateInverse = !0, this.matrix = t;
    var n = {
      set: function set(e, t, n) {
        return _this21._shouldUpdateInverse = !0, e[t] = n, !0;
      }
    };
    this._originalElements = t.elements, t.elements = new Proxy(t.elements, n);
  }

  _createClass(se, [{
    key: "revert",
    value: function revert() {
      this.matrix.elements = this._originalElements;
    }
  }, {
    key: "inverse",
    get: function get() {
      return this._shouldUpdateInverse && (oe(this._inverseCache.copy(this.matrix)), this._shouldUpdateInverse = !1), this._inverseCache;
    }
  }]);

  return se;
}();

var ae = Object.freeze(new e.Matrix4()),
    le = Object.freeze(new e.Quaternion()),
    de = new e.Vector3(),
    he = new e.Vector3(),
    ue = new e.Vector3(),
    ce = new e.Quaternion(),
    pe = new e.Matrix4(),
    me = new e.Matrix4();

var fe = /*#__PURE__*/function () {
  function fe(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, fe);

    var i, r, o, s, a, l;
    if (this._currentTail = new e.Vector3(), this._prevTail = new e.Vector3(), this._nextTail = new e.Vector3(), this._boneAxis = new e.Vector3(), this._centerSpacePosition = new e.Vector3(), this._center = null, this._parentWorldRotation = new e.Quaternion(), this._initialLocalMatrix = new e.Matrix4(), this._initialLocalRotation = new e.Quaternion(), this._initialLocalChildPosition = new e.Vector3(), this.bone = t, this.bone.matrixAutoUpdate = !1, this.radius = null !== (i = n.radius) && void 0 !== i ? i : .02, this.stiffnessForce = null !== (r = n.stiffnessForce) && void 0 !== r ? r : 1, this.gravityDir = n.gravityDir ? new e.Vector3().copy(n.gravityDir) : new e.Vector3().set(0, -1, 0), this.gravityPower = null !== (o = n.gravityPower) && void 0 !== o ? o : 0, this.dragForce = null !== (s = n.dragForce) && void 0 !== s ? s : .4, this.colliders = null !== (a = n.colliders) && void 0 !== a ? a : [], this._centerSpacePosition.setFromMatrixPosition(this.bone.matrixWorld), this._initialLocalMatrix.copy(this.bone.matrix), this._initialLocalRotation.copy(this.bone.quaternion), 0 === this.bone.children.length) this._initialLocalChildPosition.copy(this.bone.position).normalize().multiplyScalar(.07);else {
      var _e7 = this.bone.children[0];

      this._initialLocalChildPosition.copy(_e7.position);
    }
    this.bone.localToWorld(this._currentTail.copy(this._initialLocalChildPosition)), this._prevTail.copy(this._currentTail), this._nextTail.copy(this._currentTail), this._boneAxis.copy(this._initialLocalChildPosition).normalize(), this._centerSpaceBoneLength = de.copy(this._initialLocalChildPosition).applyMatrix4(this.bone.matrixWorld).sub(this._centerSpacePosition).length(), this.center = null !== (l = n.center) && void 0 !== l ? l : null;
  }

  _createClass(fe, [{
    key: "reset",
    value: function reset() {
      this.bone.quaternion.copy(this._initialLocalRotation), this.bone.updateMatrix(), this.bone.matrixWorld.multiplyMatrices(this._getParentMatrixWorld(), this.bone.matrix), this._centerSpacePosition.setFromMatrixPosition(this.bone.matrixWorld), this.bone.localToWorld(this._currentTail.copy(this._initialLocalChildPosition)), this._prevTail.copy(this._currentTail), this._nextTail.copy(this._currentTail);
    }
  }, {
    key: "update",
    value: function update(e) {
      if (e <= 0) return;
      this.bone.parent ? _(this.bone.parent, this._parentWorldRotation) : this._parentWorldRotation.copy(le), this._getMatrixWorldToCenter(pe), pe.multiply(this.bone.matrixWorld), this._centerSpacePosition.setFromMatrixPosition(pe), this._getMatrixWorldToCenter(me), me.multiply(this._getParentMatrixWorld());
      var t = this.stiffnessForce * e,
          n = he.copy(this.gravityDir).multiplyScalar(this.gravityPower * e);
      this._nextTail.copy(this._currentTail).add(de.copy(this._currentTail).sub(this._prevTail).multiplyScalar(1 - this.dragForce)).add(de.copy(this._boneAxis).applyMatrix4(this._initialLocalMatrix).applyMatrix4(me).sub(this._centerSpacePosition).normalize().multiplyScalar(t)).add(n), this._nextTail.sub(this._centerSpacePosition).normalize().multiplyScalar(this._centerSpaceBoneLength).add(this._centerSpacePosition), this._collision(this._nextTail), this._prevTail.copy(this._currentTail), this._currentTail.copy(this._nextTail);
      var i = oe(pe.copy(me.multiply(this._initialLocalMatrix))),
          r = ce.setFromUnitVectors(this._boneAxis, de.copy(this._nextTail).applyMatrix4(i).normalize());
      this.bone.quaternion.copy(this._initialLocalRotation).multiply(r), this.bone.updateMatrix(), this.bone.matrixWorld.multiplyMatrices(this._getParentMatrixWorld(), this.bone.matrix);
    }
  }, {
    key: "_collision",
    value: function _collision(e) {
      var _this22 = this;

      this.colliders.forEach(function (t) {
        _this22._getMatrixWorldToCenter(pe), pe.multiply(t.matrixWorld);
        var n = de.setFromMatrixPosition(pe),
            i = t.geometry.boundingSphere.radius,
            r = _this22.radius + i;

        if (e.distanceToSquared(n) <= r * r) {
          var _t8 = he.subVectors(e, n).normalize(),
              _i5 = ue.addVectors(n, _t8.multiplyScalar(r));

          e.copy(_i5.sub(_this22._centerSpacePosition).normalize().multiplyScalar(_this22._centerSpaceBoneLength).add(_this22._centerSpacePosition));
        }
      });
    }
  }, {
    key: "_getMatrixCenterToWorld",
    value: function _getMatrixCenterToWorld(e) {
      return this._center ? e.copy(this._center.matrixWorld) : e.identity(), e;
    }
  }, {
    key: "_getMatrixWorldToCenter",
    value: function _getMatrixWorldToCenter(e) {
      return this._center ? e.copy(this._center.userData.inverseCacheProxy.inverse) : e.identity(), e;
    }
  }, {
    key: "_getParentMatrixWorld",
    value: function _getParentMatrixWorld() {
      return this.bone.parent ? this.bone.parent.matrixWorld : ae;
    }
  }, {
    key: "center",
    get: function get() {
      return this._center;
    },
    set: function set(e) {
      var t;
      this._getMatrixCenterToWorld(pe), this._currentTail.applyMatrix4(pe), this._prevTail.applyMatrix4(pe), this._nextTail.applyMatrix4(pe), (null === (t = this._center) || void 0 === t ? void 0 : t.userData.inverseCacheProxy) && (this._center.userData.inverseCacheProxy.revert(), delete this._center.userData.inverseCacheProxy), this._center = e, this._center && (this._center.userData.inverseCacheProxy || (this._center.userData.inverseCacheProxy = new se(this._center.matrixWorld))), this._getMatrixWorldToCenter(pe), this._currentTail.applyMatrix4(pe), this._prevTail.applyMatrix4(pe), this._nextTail.applyMatrix4(pe), pe.multiply(this.bone.matrixWorld), this._centerSpacePosition.setFromMatrixPosition(pe), this._centerSpaceBoneLength = de.copy(this._initialLocalChildPosition).applyMatrix4(pe).sub(this._centerSpacePosition).length();
    }
  }]);

  return fe;
}();

var ge = /*#__PURE__*/function () {
  function ge(e, t) {
    _classCallCheck(this, ge);

    this.colliderGroups = [], this.springBoneGroupList = [], this.colliderGroups = e, this.springBoneGroupList = t;
  }

  _createClass(ge, [{
    key: "setCenter",
    value: function setCenter(e) {
      this.springBoneGroupList.forEach(function (t) {
        t.forEach(function (t) {
          t.center = e;
        });
      });
    }
  }, {
    key: "lateUpdate",
    value: function lateUpdate(e) {
      var _this23 = this;

      var t = new Set();
      this.springBoneGroupList.forEach(function (n) {
        n.forEach(function (n) {
          _this23._updateWorldMatrix(t, n.bone), n.update(e);
        });
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this24 = this;

      var e = new Set();
      this.springBoneGroupList.forEach(function (t) {
        t.forEach(function (t) {
          _this24._updateWorldMatrix(e, t.bone), t.reset();
        });
      });
    }
  }, {
    key: "_updateWorldMatrix",
    value: function _updateWorldMatrix(e, t) {
      e.has(t) || (t.parent && this._updateWorldMatrix(e, t.parent), t.updateWorldMatrix(!1, !1), e.add(t));
    }
  }]);

  return ge;
}();

var _e = new e.Vector3(),
    ve = new e.MeshBasicMaterial({
  visible: !1
});

var Te = /*#__PURE__*/function () {
  function Te() {
    _classCallCheck(this, Te);
  }

  _createClass(Te, [{
    key: "import",
    value: function _import(e) {
      var t;
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var n, i, r, o;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                n = null === (t = e.parser.json.extensions) || void 0 === t ? void 0 : t.VRM;

                if (n) {
                  _context15.next = 3;
                  break;
                }

                return _context15.abrupt("return", null);

              case 3:
                i = n.secondaryAnimation;

                if (i) {
                  _context15.next = 6;
                  break;
                }

                return _context15.abrupt("return", null);

              case 6:
                _context15.next = 8;
                return this._importColliderMeshGroups(e, i);

              case 8:
                r = _context15.sent;
                _context15.next = 11;
                return this._importSpringBoneGroupList(e, i, r);

              case 11:
                o = _context15.sent;
                return _context15.abrupt("return", new ge(r, o));

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "_createSpringBone",
    value: function _createSpringBone(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new fe(e, t);
    }
  }, {
    key: "_importSpringBoneGroupList",
    value: function _importSpringBoneGroupList(t, i, r) {
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _this25 = this;

        var o, s;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                o = i.boneGroups || [], s = [];
                _context18.next = 3;
                return Promise.all(o.map(function (i) {
                  return n(_this25, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
                    var _this26 = this;

                    var o, a, l, d, h, u, c;
                    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            if (!(void 0 === i.stiffiness || void 0 === i.gravityDir || void 0 === i.gravityDir.x || void 0 === i.gravityDir.y || void 0 === i.gravityDir.z || void 0 === i.gravityPower || void 0 === i.dragForce || void 0 === i.hitRadius || void 0 === i.colliderGroups || void 0 === i.bones || void 0 === i.center)) {
                              _context17.next = 2;
                              break;
                            }

                            return _context17.abrupt("return");

                          case 2:
                            o = i.stiffiness, a = new e.Vector3(i.gravityDir.x, i.gravityDir.y, -i.gravityDir.z), l = i.gravityPower, d = i.dragForce, h = i.hitRadius, u = [];
                            i.colliderGroups.forEach(function (e) {
                              u.push.apply(u, _toConsumableArray(r[e].colliders));
                            });
                            c = [];
                            _context17.next = 7;
                            return Promise.all(i.bones.map(function (e) {
                              return n(_this26, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
                                var _this27 = this;

                                var n, r;
                                return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                                  while (1) {
                                    switch (_context16.prev = _context16.next) {
                                      case 0:
                                        _context16.next = 2;
                                        return t.parser.getDependency("node", e);

                                      case 2:
                                        n = _context16.sent;

                                        if (!(-1 !== i.center)) {
                                          _context16.next = 9;
                                          break;
                                        }

                                        _context16.next = 6;
                                        return t.parser.getDependency("node", i.center);

                                      case 6:
                                        _context16.t0 = _context16.sent;
                                        _context16.next = 10;
                                        break;

                                      case 9:
                                        _context16.t0 = null;

                                      case 10:
                                        r = _context16.t0;
                                        n && n.traverse(function (e) {
                                          var t = _this27._createSpringBone(e, {
                                            radius: h,
                                            stiffnessForce: o,
                                            gravityDir: a,
                                            gravityPower: l,
                                            dragForce: d,
                                            colliders: u,
                                            center: r
                                          });

                                          c.push(t);
                                        });

                                      case 12:
                                      case "end":
                                        return _context16.stop();
                                    }
                                  }
                                }, _callee16);
                              }));
                            }));

                          case 7:
                            s.push(c);

                          case 8:
                          case "end":
                            return _context17.stop();
                        }
                      }
                    }, _callee17);
                  }));
                }));

              case 3:
                return _context18.abrupt("return", s);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));
    }
  }, {
    key: "_importColliderMeshGroups",
    value: function _importColliderMeshGroups(e, t) {
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _this28 = this;

        var i, r;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                i = t.colliderGroups;

                if (!(void 0 === i)) {
                  _context20.next = 3;
                  break;
                }

                return _context20.abrupt("return", []);

              case 3:
                r = [];
                return _context20.abrupt("return", (i.forEach(function (t) {
                  return n(_this28, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                    var _this29 = this;

                    var n, i, o;
                    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                      while (1) {
                        switch (_context19.prev = _context19.next) {
                          case 0:
                            if (!(void 0 === t.node || void 0 === t.colliders)) {
                              _context19.next = 2;
                              break;
                            }

                            return _context19.abrupt("return");

                          case 2:
                            _context19.next = 4;
                            return e.parser.getDependency("node", t.node);

                          case 4:
                            n = _context19.sent;
                            i = [];
                            t.colliders.forEach(function (e) {
                              if (void 0 === e.offset || void 0 === e.offset.x || void 0 === e.offset.y || void 0 === e.offset.z || void 0 === e.radius) return;

                              var t = _e.set(e.offset.x, e.offset.y, -e.offset.z),
                                  r = _this29._createColliderMesh(e.radius, t);

                              n.add(r), i.push(r);
                            });
                            o = {
                              node: t.node,
                              colliders: i
                            };
                            r.push(o);

                          case 9:
                          case "end":
                            return _context19.stop();
                        }
                      }
                    }, _callee19);
                  }));
                }), r));

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));
    }
  }, {
    key: "_createColliderMesh",
    value: function _createColliderMesh(t, n) {
      var i = new e.Mesh(new e.SphereBufferGeometry(t, 8, 4), ve);
      return i.position.copy(n), i.name = "vrmColliderSphere", i.geometry.computeBoundingSphere(), i;
    }
  }]);

  return Te;
}();

var ye = /*#__PURE__*/function () {
  function ye() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ye);

    this._metaImporter = e.metaImporter || new ie(), this._blendShapeImporter = e.blendShapeImporter || new T(), this._lookAtImporter = e.lookAtImporter || new z(), this._humanoidImporter = e.humanoidImporter || new b(), this._firstPersonImporter = e.firstPersonImporter || new L(), this._materialImporter = e.materialImporter || new ne(), this._springBoneImporter = e.springBoneImporter || new Te();
  }

  _createClass(ye, [{
    key: "import",
    value: function _import(e) {
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var t, n, i, r, o, s, a, l;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(void 0 === e.parser.json.extensions || void 0 === e.parser.json.extensions.VRM)) {
                  _context21.next = 2;
                  break;
                }

                throw new Error("Could not find VRM extension on the GLTF");

              case 2:
                t = e.scene;
                t.updateMatrixWorld(!1), t.traverse(function (e) {
                  e.isMesh && (e.frustumCulled = !1);
                });
                _context21.next = 6;
                return this._metaImporter.import(e);

              case 6:
                _context21.t0 = _context21.sent;

                if (_context21.t0) {
                  _context21.next = 9;
                  break;
                }

                _context21.t0 = void 0;

              case 9:
                n = _context21.t0;
                _context21.next = 12;
                return this._materialImporter.convertGLTFMaterials(e);

              case 12:
                _context21.t1 = _context21.sent;

                if (_context21.t1) {
                  _context21.next = 15;
                  break;
                }

                _context21.t1 = void 0;

              case 15:
                i = _context21.t1;
                _context21.next = 18;
                return this._humanoidImporter.import(e);

              case 18:
                _context21.t2 = _context21.sent;

                if (_context21.t2) {
                  _context21.next = 21;
                  break;
                }

                _context21.t2 = void 0;

              case 21:
                r = _context21.t2;
                _context21.t4 = r;

                if (!_context21.t4) {
                  _context21.next = 27;
                  break;
                }

                _context21.next = 26;
                return this._firstPersonImporter.import(e, r);

              case 26:
                _context21.t4 = _context21.sent;

              case 27:
                _context21.t3 = _context21.t4;

                if (_context21.t3) {
                  _context21.next = 30;
                  break;
                }

                _context21.t3 = void 0;

              case 30:
                o = _context21.t3;
                _context21.next = 33;
                return this._blendShapeImporter.import(e);

              case 33:
                _context21.t5 = _context21.sent;

                if (_context21.t5) {
                  _context21.next = 36;
                  break;
                }

                _context21.t5 = void 0;

              case 36:
                s = _context21.t5;
                _context21.t7 = o && s && r;

                if (!_context21.t7) {
                  _context21.next = 42;
                  break;
                }

                _context21.next = 41;
                return this._lookAtImporter.import(e, o, s, r);

              case 41:
                _context21.t7 = _context21.sent;

              case 42:
                _context21.t6 = _context21.t7;

                if (_context21.t6) {
                  _context21.next = 45;
                  break;
                }

                _context21.t6 = void 0;

              case 45:
                a = _context21.t6;
                _context21.next = 48;
                return this._springBoneImporter.import(e);

              case 48:
                _context21.t8 = _context21.sent;

                if (_context21.t8) {
                  _context21.next = 51;
                  break;
                }

                _context21.t8 = void 0;

              case 51:
                l = _context21.t8;
                return _context21.abrupt("return", new xe({
                  scene: e.scene,
                  meta: n,
                  materials: i,
                  humanoid: r,
                  firstPerson: o,
                  blendShapeProxy: s,
                  lookAt: a,
                  springBoneManager: l
                }));

              case 53:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }]);

  return ye;
}();

var xe = /*#__PURE__*/function () {
  function xe(e) {
    _classCallCheck(this, xe);

    this.scene = e.scene, this.humanoid = e.humanoid, this.blendShapeProxy = e.blendShapeProxy, this.firstPerson = e.firstPerson, this.lookAt = e.lookAt, this.materials = e.materials, this.springBoneManager = e.springBoneManager, this.meta = e.meta;
  }

  _createClass(xe, [{
    key: "update",
    value: function update(e) {
      this.lookAt && this.lookAt.update(e), this.blendShapeProxy && this.blendShapeProxy.update(), this.springBoneManager && this.springBoneManager.lateUpdate(e), this.materials && this.materials.forEach(function (t) {
        t.updateVRMMaterials && t.updateVRMMaterials(e);
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var e, t;
      var n = this.scene;
      n && n.traverse(r), null === (t = null === (e = this.meta) || void 0 === e ? void 0 : e.texture) || void 0 === t || t.dispose();
    }
  }], [{
    key: "from",
    value: function from(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var n;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                n = new ye(t);
                _context22.next = 3;
                return n.import(e);

              case 3:
                return _context22.abrupt("return", _context22.sent);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));
    }
  }]);

  return xe;
}();

var Se = new e.Vector2(),
    Me = new e.OrthographicCamera(-1, 1, -1, 1, -1, 1),
    Ee = new e.MeshBasicMaterial({
  color: 16777215,
  side: e.DoubleSide
}),
    Le = new e.Mesh(new e.PlaneBufferGeometry(2, 2), Ee),
    Re = new e.Scene();
Re.add(Le);

var we = function we() {
  _classCallCheck(this, we);
};

we.extractThumbnailBlob = function (e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
  var i;
  var r = null === (i = t.meta) || void 0 === i ? void 0 : i.texture;
  if (!r) throw new Error("extractThumbnailBlob: This VRM does not have a thumbnail");
  var o = e.getContext().canvas;
  e.getSize(Se);
  var s = Se.x,
      a = Se.y;
  return e.setSize(n, n, !1), Ee.map = r, e.render(Re, Me), Ee.map = null, o instanceof OffscreenCanvas ? o.convertToBlob().finally(function () {
    e.setSize(s, a, !1);
  }) : new Promise(function (t, n) {
    o.toBlob(function (i) {
      e.setSize(s, a, !1), null == i ? n("extractThumbnailBlob: Failed to create a blob") : t(i);
    });
  });
}, we.removeUnnecessaryJoints = function (t) {
  var n = new Map();
  t.traverse(function (t) {
    if ("SkinnedMesh" !== t.type) return;
    var i = t,
        r = i.geometry.getAttribute("skinIndex");
    var o = n.get(r);

    if (!o) {
      var _t9 = [],
          _s2 = [],
          a = {},
          _l2 = r.array;

      for (var _e8 = 0; _e8 < _l2.length; _e8++) {
        var _n7 = _l2[_e8];
        void 0 === a[_n7] && (a[_n7] = _t9.length, _t9.push(i.skeleton.bones[_n7]), _s2.push(i.skeleton.boneInverses[_n7])), _l2[_e8] = a[_n7];
      }

      r.copyArray(_l2), r.needsUpdate = !0, o = new e.Skeleton(_t9, _s2), n.set(r, o);
    }

    i.bind(o, new e.Matrix4());
  });
}, we.removeUnnecessaryVertices = function (n) {
  var i = new Map();
  n.traverse(function (n) {
    var r, o, s, a;
    if (!n.isMesh) return;
    var l = n,
        d = l.geometry,
        h = d.index;
    if (null == h) return;
    var u = i.get(d);
    if (null != u) return void (l.geometry = u);
    var c = new e.BufferGeometry();
    c.name = d.name, c.morphTargetsRelative = d.morphTargetsRelative, d.groups.forEach(function (e) {
      c.addGroup(e.start, e.count, e.materialIndex);
    }), c.boundingBox = null !== (o = null === (r = d.boundingBox) || void 0 === r ? void 0 : r.clone()) && void 0 !== o ? o : null, c.boundingSphere = null !== (a = null === (s = d.boundingSphere) || void 0 === s ? void 0 : s.clone()) && void 0 !== a ? a : null, c.setDrawRange(d.drawRange.start, d.drawRange.count), c.userData = d.userData, i.set(d, c);
    var p = [],
        m = [];
    {
      var _e9 = h.array,
          _n8 = new _e9.constructor(_e9.length);

      var _i6 = 0;

      for (var _t10 = 0; _t10 < _e9.length; _t10++) {
        var _r5 = _e9[_t10];
        var _o3 = p[_r5];
        null == _o3 && (p[_r5] = _i6, m[_i6] = _r5, _o3 = _i6, _i6++), _n8[_t10] = _o3;
      }

      c.setIndex(new t(_n8, 1, !1));
    }
    Object.keys(d.attributes).forEach(function (e) {
      var n = d.attributes[e];
      if (n.isInterleavedBufferAttribute) throw new Error("removeUnnecessaryVertices: InterleavedBufferAttribute is not supported");
      var i = n.array,
          r = n.itemSize,
          o = n.normalized,
          s = new i.constructor(m.length * r);
      m.forEach(function (e, t) {
        for (var _n9 = 0; _n9 < r; _n9++) {
          s[t * r + _n9] = i[e * r + _n9];
        }
      }), c.setAttribute(e, new t(s, r, o));
    });
    var f = !0;
    Object.keys(d.morphAttributes).forEach(function (e) {
      c.morphAttributes[e] = [];
      var n = d.morphAttributes[e];

      var _loop3 = function _loop3(_i7) {
        var r = n[_i7];
        if (r.isInterleavedBufferAttribute) throw new Error("removeUnnecessaryVertices: InterleavedBufferAttribute is not supported");
        var o = r.array,
            s = r.itemSize,
            a = r.normalized,
            l = new o.constructor(m.length * s);
        m.forEach(function (e, t) {
          for (var _n10 = 0; _n10 < s; _n10++) {
            l[t * s + _n10] = o[e * s + _n10];
          }
        }), f = f && l.every(function (e) {
          return 0 === e;
        }), c.morphAttributes[e][_i7] = new t(l, s, a);
      };

      for (var _i7 = 0; _i7 < n.length; _i7++) {
        _loop3(_i7);
      }
    }), f && (c.morphAttributes = {}), l.geometry = c;
  }), Array.from(i.keys()).forEach(function (e) {
    e.dispose();
  });
};
var Pe = new e.Vector3();

var Ae = /*#__PURE__*/function (_H) {
  _inherits(Ae, _H);

  function Ae() {
    _classCallCheck(this, Ae);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ae).apply(this, arguments));
  }

  _createClass(Ae, [{
    key: "setupHelper",
    value: function setupHelper(t, n) {
      n.disableFaceDirectionHelper || (this._faceDirectionHelper = new e.ArrowHelper(new e.Vector3(0, 0, -1), new e.Vector3(0, 0, 0), .5, 16711935), t.add(this._faceDirectionHelper));
    }
  }, {
    key: "update",
    value: function update(e) {
      _get(_getPrototypeOf(Ae.prototype), "update", this).call(this, e), this._faceDirectionHelper && (this.firstPerson.getFirstPersonWorldPosition(this._faceDirectionHelper.position), this._faceDirectionHelper.setDirection(this.getLookAtWorldDirection(Pe)));
    }
  }]);

  return Ae;
}(H);

var Ie = /*#__PURE__*/function (_z) {
  _inherits(Ie, _z);

  function Ie() {
    _classCallCheck(this, Ie);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ie).apply(this, arguments));
  }

  _createClass(Ie, [{
    key: "import",
    value: function _import(e, t, n, i) {
      var r;
      var o = null === (r = e.parser.json.extensions) || void 0 === r ? void 0 : r.VRM;
      if (!o) return null;
      var s = o.firstPerson;
      if (!s) return null;

      var a = this._importApplyer(s, n, i);

      return new Ae(t, a || void 0);
    }
  }]);

  return Ie;
}(z);

var be = new e.MeshBasicMaterial({
  color: 16711935,
  wireframe: !0,
  transparent: !0,
  depthTest: !1
});

var Oe = /*#__PURE__*/function (_ge) {
  _inherits(Oe, _ge);

  function Oe() {
    _classCallCheck(this, Oe);

    return _possibleConstructorReturn(this, _getPrototypeOf(Oe).apply(this, arguments));
  }

  _createClass(Oe, [{
    key: "setupHelper",
    value: function setupHelper(e, t) {
      t.disableSpringBoneHelper || (this.springBoneGroupList.forEach(function (t) {
        t.forEach(function (t) {
          if (t.getGizmo) {
            var _n11 = t.getGizmo();

            e.add(_n11);
          }
        });
      }), this.colliderGroups.forEach(function (e) {
        e.colliders.forEach(function (e) {
          e.material = be, e.renderOrder = Ve;
        });
      }));
    }
  }]);

  return Oe;
}(ge);

var Ce = new e.Vector3();

var Ne = /*#__PURE__*/function (_fe) {
  _inherits(Ne, _fe);

  function Ne(e, t) {
    _classCallCheck(this, Ne);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ne).call(this, e, t));
  }

  _createClass(Ne, [{
    key: "getGizmo",
    value: function getGizmo() {
      if (this._gizmo) return this._gizmo;
      var t = Ce.copy(this._nextTail).sub(this._centerSpacePosition),
          n = t.length();
      return this._gizmo = new e.ArrowHelper(t.normalize(), this._centerSpacePosition, n, 16776960, this.radius, this.radius), this._gizmo.line.renderOrder = Ve, this._gizmo.cone.renderOrder = Ve, this._gizmo.line.material.depthTest = !1, this._gizmo.line.material.transparent = !0, this._gizmo.cone.material.depthTest = !1, this._gizmo.cone.material.transparent = !0, this._gizmo;
    }
  }, {
    key: "update",
    value: function update(e) {
      _get(_getPrototypeOf(Ne.prototype), "update", this).call(this, e), this._updateGizmo();
    }
  }, {
    key: "_updateGizmo",
    value: function _updateGizmo() {
      if (!this._gizmo) return;
      var e = Ce.copy(this._currentTail).sub(this._centerSpacePosition),
          t = e.length();
      this._gizmo.setDirection(e.normalize()), this._gizmo.setLength(t, this.radius, this.radius), this._gizmo.position.copy(this._centerSpacePosition);
    }
  }]);

  return Ne;
}(fe);

var De = /*#__PURE__*/function (_Te) {
  _inherits(De, _Te);

  function De() {
    _classCallCheck(this, De);

    return _possibleConstructorReturn(this, _getPrototypeOf(De).apply(this, arguments));
  }

  _createClass(De, [{
    key: "import",
    value: function _import(e) {
      var t;
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var n, i, r, o;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                n = null === (t = e.parser.json.extensions) || void 0 === t ? void 0 : t.VRM;

                if (n) {
                  _context23.next = 3;
                  break;
                }

                return _context23.abrupt("return", null);

              case 3:
                i = n.secondaryAnimation;

                if (i) {
                  _context23.next = 6;
                  break;
                }

                return _context23.abrupt("return", null);

              case 6:
                _context23.next = 8;
                return this._importColliderMeshGroups(e, i);

              case 8:
                r = _context23.sent;
                _context23.next = 11;
                return this._importSpringBoneGroupList(e, i, r);

              case 11:
                o = _context23.sent;
                return _context23.abrupt("return", new Oe(r, o));

              case 13:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "_createSpringBone",
    value: function _createSpringBone(e, t) {
      return new Ne(e, t);
    }
  }]);

  return De;
}(Te);

var Ue = /*#__PURE__*/function (_ye) {
  _inherits(Ue, _ye);

  function Ue() {
    var _this30;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Ue);

    e.lookAtImporter = e.lookAtImporter || new Ie(), e.springBoneImporter = e.springBoneImporter || new De(), _this30 = _possibleConstructorReturn(this, _getPrototypeOf(Ue).call(this, e));
    return _this30;
  }

  _createClass(Ue, [{
    key: "import",
    value: function _import(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var n, i, r, o, s, a, l, d;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!(void 0 === e.parser.json.extensions || void 0 === e.parser.json.extensions.VRM)) {
                  _context24.next = 2;
                  break;
                }

                throw new Error("Could not find VRM extension on the GLTF");

              case 2:
                n = e.scene;
                n.updateMatrixWorld(!1), n.traverse(function (e) {
                  e.isMesh && (e.frustumCulled = !1);
                });
                _context24.next = 6;
                return this._metaImporter.import(e);

              case 6:
                _context24.t0 = _context24.sent;

                if (_context24.t0) {
                  _context24.next = 9;
                  break;
                }

                _context24.t0 = void 0;

              case 9:
                i = _context24.t0;
                _context24.next = 12;
                return this._materialImporter.convertGLTFMaterials(e);

              case 12:
                _context24.t1 = _context24.sent;

                if (_context24.t1) {
                  _context24.next = 15;
                  break;
                }

                _context24.t1 = void 0;

              case 15:
                r = _context24.t1;
                _context24.next = 18;
                return this._humanoidImporter.import(e);

              case 18:
                _context24.t2 = _context24.sent;

                if (_context24.t2) {
                  _context24.next = 21;
                  break;
                }

                _context24.t2 = void 0;

              case 21:
                o = _context24.t2;
                _context24.t4 = o;

                if (!_context24.t4) {
                  _context24.next = 27;
                  break;
                }

                _context24.next = 26;
                return this._firstPersonImporter.import(e, o);

              case 26:
                _context24.t4 = _context24.sent;

              case 27:
                _context24.t3 = _context24.t4;

                if (_context24.t3) {
                  _context24.next = 30;
                  break;
                }

                _context24.t3 = void 0;

              case 30:
                s = _context24.t3;
                _context24.next = 33;
                return this._blendShapeImporter.import(e);

              case 33:
                _context24.t5 = _context24.sent;

                if (_context24.t5) {
                  _context24.next = 36;
                  break;
                }

                _context24.t5 = void 0;

              case 36:
                a = _context24.t5;
                _context24.t7 = s && a && o;

                if (!_context24.t7) {
                  _context24.next = 42;
                  break;
                }

                _context24.next = 41;
                return this._lookAtImporter.import(e, s, a, o);

              case 41:
                _context24.t7 = _context24.sent;

              case 42:
                _context24.t6 = _context24.t7;

                if (_context24.t6) {
                  _context24.next = 45;
                  break;
                }

                _context24.t6 = void 0;

              case 45:
                l = _context24.t6;
                l.setupHelper && l.setupHelper(n, t);
                _context24.next = 49;
                return this._springBoneImporter.import(e);

              case 49:
                _context24.t8 = _context24.sent;

                if (_context24.t8) {
                  _context24.next = 52;
                  break;
                }

                _context24.t8 = void 0;

              case 52:
                d = _context24.t8;
                return _context24.abrupt("return", (d.setupHelper && d.setupHelper(n, t), new Be({
                  scene: e.scene,
                  meta: i,
                  materials: r,
                  humanoid: o,
                  firstPerson: s,
                  blendShapeProxy: a,
                  lookAt: l,
                  springBoneManager: d
                }, t)));

              case 54:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }]);

  return Ue;
}(ye);

var Ve = 1e4;

var Be = /*#__PURE__*/function (_xe) {
  _inherits(Be, _xe);

  _createClass(Be, null, [{
    key: "from",
    value: function from(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var n;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                n = new Ue(t);
                _context25.next = 3;
                return n.import(e, i);

              case 3:
                return _context25.abrupt("return", _context25.sent);

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));
    }
  }]);

  function Be(t) {
    var _this31;

    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Be);

    _this31 = _possibleConstructorReturn(this, _getPrototypeOf(Be).call(this, t)), n.disableBoxHelper || _this31.scene.add(new e.BoxHelper(_this31.scene)), n.disableSkeletonHelper || _this31.scene.add(new e.SkeletonHelper(_this31.scene));
    return _this31;
  }

  _createClass(Be, [{
    key: "update",
    value: function update(e) {
      _get(_getPrototypeOf(Be.prototype), "update", this).call(this, e);
    }
  }]);

  return Be;
}(xe);

export { K as MToonMaterial, q as MToonMaterialCullMode, Q as MToonMaterialDebugMode, Z as MToonMaterialOutlineColorMode, $ as MToonMaterialOutlineWidthMode, J as MToonMaterialRenderMode, xe as VRM, h as VRMBlendShapeGroup, T as VRMBlendShapeImporter, v as VRMBlendShapeProxy, O as VRMCurveMapper, Be as VRMDebug, E as VRMFirstPerson, L as VRMFirstPersonImporter, R as VRMHumanBone, I as VRMHumanoid, b as VRMHumanoidImporter, ye as VRMImporter, C as VRMLookAtApplyer, N as VRMLookAtBlendShapeApplyer, k as VRMLookAtBoneApplyer, H as VRMLookAtHead, z as VRMLookAtImporter, ne as VRMMaterialImporter, ie as VRMMetaImporter, M as VRMRendererFirstPersonFlags, u as VRMSchema, fe as VRMSpringBone, Ne as VRMSpringBoneDebug, Te as VRMSpringBoneImporter, De as VRMSpringBoneImporterDebug, ge as VRMSpringBoneManager, te as VRMUnlitMaterial, ee as VRMUnlitMaterialRenderType, we as VRMUtils, Ve as VRM_GIZMO_RENDER_ORDER };